export default {
  common: {
    edit: 'Modifica',
    yes: 'Sì',
    no: 'No',
    or: 'o',
    search: 'Cerca',
    none: 'Nessuno',
    save: 'Salva',
    error: 'Errore',
    reset: 'Reimposta',
    input: 'Input',
    cancel: 'Annulla',
    next: 'Avanti',
    back: 'Indietro',
    selectHeaders: 'Seleziona intestazioni visibili',
    weekday: 'Giorno feriale',
    from: 'Da',
    delete: 'Elimina',
    to: 'A',
    deliveryAt: 'Consegna il',
    ok: 'Ok',
    add: 'Aggiungi',
    disable: 'Disabilita',
    enable: 'Abilita',
    remove: 'Rimuovi',
    empty: "Non c'è nulla da vedere qui.",
    selectToImport: 'Seleziona un file da importare',
    selectVenue: 'Seleziona un punto vendita.',
    import: 'Importa',
    export: 'Esporta',
    legacyExport: 'Esportazione Legacy',
    file: 'File',
    apply: 'Applica',
    applySelectedFilters: 'Applica filtri selezionati',
    filters: 'Filtro',
    orders: 'Ordini',
    overview: 'Panoramica',
    others: 'Altri',
    skip: 'Salta',
    time: 'Ora',
    date: 'Data',
    register: 'Registrati',
    submit: 'Invia',
    confirmDelete: 'Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata.',
    form: {
      file: 'File',
    },
    all: 'Tutti',
    single: 'Singolo',
    teedeli: 'Teedeli',
    selectItems: 'Seleziona almeno un elemento.',
    noSelection: 'Nessuna selezione',
    description: 'Descrizione',
    invoice: 'Fattura',
    name: 'Nome',
    tag: 'Etichetta',
    tags: 'Etichette',
    test: 'Test',
    shoppingCart: 'Carrello',
    send: 'Invia',
    recommendation: 'Raccomandazione',
    generate: 'Genera',
    selectAll: 'Seleziona tutto',
    singleImageAllowed: 'È consentita una sola immagine!',
    imageFilesOnly: 'Sono consentiti solo file immagine!',
    fileSizeExceed: 'La dimensione del file supera il massimo di {max}MB!',
    imageMaxSizeNotice: "L'immagine deve avere una dimensione massima di {max}MB!",
    copyId: 'Copia ID',
    copiedToClipboard: 'Copiato negli appunti!',
    imagesDragAndDrop: 'Trascina e rilascia',
    browseFiles: 'Sfoglia file',
    videoPreview: 'Anteprima video',
    fileName: 'Nome file',
    fileSize: 'Dimensione file',
    videoDuration: 'Durata video',
    videoResolution: 'Risoluzione video',
    uploadProgress: 'Avanzamento caricamento',
    uploadVideo: 'Carica video',
    videoFileOnly: 'Solo file video!',
    dragAndDropVideoHere: 'Trascina il tuo video qui',
    uploadComplete: 'Caricamento completato',
  },
  feedback: {
    title: 'Invia feedback',
    fields: {
      name: 'Nome',
      email: 'Email',
      comments: 'Cosa è successo?',
    },
    actions: {
      open: 'Apri finestra di feedback',
      submit: 'Invia feedback',
    },
    notification: {
      sent: 'Feedback inviato.',
    },
  },
  languageField: {
    add: 'Aggiungi altro',
    picker: 'Lingua',
  },
  countries: {
    de: 'Germania',
    au: 'Austria',
    fr: 'Francia',
    li: 'Liechtenstein',
    lu: 'Lussemburgo',
    ch: 'Svizzera',
    es: 'Spagna',
    is: 'Islanda',
    ic: 'Isole Canarie',
    pt: 'Portogallo',
    cz: 'Repubblica Ceca',
    nl: 'Paesi Bassi',
    be: 'Belgio',
    no: 'Norvegia',
    dk: 'Danimarca',
    se: 'Svezia',
    ae: 'EAU',
    lt: 'Lituania',
    fi: 'Finlandia',
    gb: 'Regno Unito',
    it: 'Italia',
  },
  toolbar: {
    selectOrSearchVenue: 'Seleziona o cerca punto vendita...',
    noSelection: 'Nessun punto vendita selezionato',
    copyShortId: 'Copia ID breve',
  },
  masterTypes: {
    web: 'Web',
    terminal: 'Terminale',
  },
  login: {
    caption: 'Smoothr è la scorciatoia per la digitalizzazione del tuo ristorante.',
  },
  dashboard: {
    index: 'Dashboard',
    totalSum: 'Ricavi Totali',
    totalVenues: 'Visualizzazione risultati di {total} punti vendita.',
    totalNetSum: 'Ricavi Netti Totali',
    orderSum: 'Numero di Ordini',
    provisionSum: 'Provvigione',
    form: {
      customerGroup: 'Seleziona Gruppo Clienti',
    },
    table: {
      total: 'Totale',
      totalNet: 'Totale Netto',
      numberOfOrders: 'Numero di Ordini',
      venue: 'Punto Vendita',
      readableId: 'ID Breve',
      provision: 'Provvigione',
    },
  },
  provision: {
    index: 'Provvigione',
    overview: 'Panoramica',
    claim: 'Richiedi Provvigione',
    select: 'Seleziona o cerca punto vendita per visualizzare i pagamenti',
    claimHelp: 'Seleziona un punto vendita e un periodo per richiedere la provvigione.',
    success: 'Successo',
    sum: 'Somma',
    waiting: 'In attesa',
    notClaimed: 'Non richiesta',
    notification: {
      claiming: 'La provvigione verrà richiesta. Dopo qualche minuto, aggiorna il sito per vedere le modifiche.',
    },
    form: {
      venue: 'Punto Vendita',
    },
    table: {
      sum: 'PrezzoTotale',
      method: 'Metodo',
      status: 'Stato',
      createdAt: 'Creato il',
      provision: 'Stato Provvigione',
      provisionClaimedAt: 'Richiesto il',
    },
  },
  inventory: {
    index: 'Inventario',
    overview: 'Panoramica',
    stock: 'Magazzino',
    product: 'Prodotti',
    add: 'Crea',
    form: {
      stock: 'Magazzino',
      product: 'Seleziona prodotti',
    },
    table: {
      stock: 'Magazzino',
      inventoryItems: 'Prodotti',
      createdAt: 'Creato il',
    },
  },
  company: {
    index: 'Azienda',
    overview: 'Panoramica',
    general: 'Dettagli',
    deliveryAddress: 'Indirizzo di Consegna',
    invoiceAddress: 'Indirizzo di Fatturazione',
    add: 'Crea',
    create: 'Crea',
    edit: 'Modifica',
    form: {
      venue: 'Punto Vendita',
      name: 'Nome',
      companyCode: 'Codice Azienda',
      email: 'E-Mail',
      phoneNumber: 'Numero di Telefono',
      vatNumber: 'Partita IVA',
      orderMinimum: 'Ordine Minimo',
      subsidy: 'Sussidio',
      subsidyOrderMinimum: 'Ordine Minimo Sussidio',
      paymentMethod: 'Metodo di Pagamento',
      iban: 'IBAN',
      storeDiscount: 'Sconto Negozio (%)',
      isPaidByCompany: "Pagato dall'Azienda",
      city: 'Città',
      area: 'Città più Vicina',
      street: 'Via',
      streetAddress: 'Indirizzo',
      number: 'Numero',
      company: 'Azienda',
      postalCode: 'Codice Postale',
      gpsManualInput: 'Inserimento Manuale (Coordinate GPS)',
      gpsCorrect: 'Coordinate GPS corrette?',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      deliveryTime: 'Tempo di Consegna',
      useDeliveryAddressAsInvoice: 'Usa Indirizzo di Consegna per Fatturazione',
    },
    table: {
      venue: 'Punto Vendita',
      name: 'Nome',
      createdAt: 'Creato il',
      companyCode: 'Codice Azienda',
      email: 'E-Mail',
      phoneNumber: 'Numero di Telefono',
      vatNumber: 'Partita IVA',
    },
    tabs: {
      general: 'Generale',
      openingHours: 'Orari di Apertura',
      deliveryTime: 'Tempo di Consegna',
    },
    notification: {
      emptyOpeningHours: 'Gli orari di apertura sono vuoti. Imposta gli orari di apertura.',
    },
  },
  uiBanner: {
    index: 'Banner',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea',
    create: 'Crea',
    edit: 'Modifica',
    empty: 'Sembra che tu non abbia ancora aggiunto nessun UI Banner. Crea ora il tuo primo UI Banner!',
  },
  uiCard: {
    index: 'Card',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea',
    create: 'Crea',
    edit: 'Modifica',
    empty: 'Sembra che tu non abbia ancora aggiunto nessuna UI Card. Crea ora la tua prima UI Card!',
  },
  uiSlider: {
    index: 'Slider',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea',
    create: 'Crea',
    edit: 'Modifica',
    empty: 'Sembra che tu non abbia ancora aggiunto nessun UI Slider. Crea ora il tuo primo UI Slider!',
  },
  notification: {
    form: 'Si prega di compilare il modulo.',
    400: 'La richiesta non era valida.',
    401: 'Le tue credenziali non sono valide.',
    422: 'Si è verificato un errore di convalida imprevisto. Controlla il modulo.',
    404: 'La risorsa richiesta non è stata trovata.',
    403: 'Non sei autorizzato a visualizzare questa pagina.',
    500: 'Si è verificato un errore interno del server.',
    mfa: 'Il codice MFA non è valido.',
    unknown: 'Si è verificato un errore sconosciuto.',
    downloadInProgress:
      'Il tuo download verrà preparato. Puoi ancora navigare sul sito. Il download del tuo file inizierà automaticamente quando sarà pronto.',
    downloadFailed: 'Uno dei tuoi download non è riuscito. Riprova più tardi.',
    downloadSuccess: 'Il tuo download è pronto!',
    gpsError:
      "Posizione GPS per l'indirizzo fornito non trovata. Modifica l'indirizzo o inserisci le coordinate GPS manualmente.",
    successfulDownload: "L'esportazione è stata inviata al tuo indirizzo email",
    retryCheckoutIntegrationAction: 'Riprova riuscita',
    needOpeningHours: 'Imposta prima gli orari di apertura!',
    needDeliveryHours: 'Imposta prima gli orari di consegna!',
    visibleOptionGroupError: 'Questo gruppo di opzioni è obbligatorio. Almeno 1 articolo opzione deve essere visibile',
  },
  gender: {
    index: 'Genere',
    male: 'Maschio',
    female: 'Femmina',
    other: 'Altro',
  },
  displayModes: {
    default: 'Predefinito',
    launcher: 'Avviatore',
    smartPicker: 'Selettore Intelligente',
    detailOverlay: 'Sovrapposizione Dettagli',
    detailDialog: 'Dialogo Dettagli',
    grid: 'Griglia',
    pagedGrid: 'Griglia Paginata',
    circle: 'Cerchio',
    topSeller: 'Più Venduti',
    matrix: 'Matrice',
    banner: 'Banner',
    drinkFlavor: 'Gusto Bevanda',
    toggleButton: 'Pulsante Attiva/Disattiva',
    flavor: 'Gusto',
    checkbox: 'Casella di Controllo',
    radio: 'Pulsante Radio',
    code: 'Codice',
  },
  displayIdentifiers: {
    extra: 'Extra',
    extra15: 'Extra 15',
    extra30: 'Extra 30',
    extraCheese15: 'Extra Formaggio 15',
    extraCheese30: 'Extra Formaggio 30',
    size: 'Dimensione',
    size15: 'Dimensione 15',
    size30: 'Dimensione 30',
    cheese: 'Formaggio',
    kids: 'Bambini',
    salad: 'Insalata',
    bread: 'Pane',
    cookie1: '1x Biscotto',
    cookie3: '3x Biscotto',
    cookie12: '12x Biscotto',
    chips: 'Patatine',
    sauce: 'Salsa',
    drink: 'Bevanda',
    water: 'Acqua',
    tea: 'Tè',
    hotBeverages: 'Bevande Calde',
    menu: 'Menu',
    main: 'Principale',
    sub: 'Secondario',
    wrap: 'Wrap',
    sides: 'Contorni',
    fullPrice: 'Prezzo Pieno',
    inverse: 'Inverso',
    code: 'Codice',
  },
  venueSelector: {
    title: 'Seleziona Punto Vendita',
    search: 'Seleziona un punto vendita',
    back: 'Torna ai punti vendita',
  },
  currency: {
    eur: 'Euro',
    chf: 'Franco Svizzero',
    isk: 'Corona islandese',
    czk: 'Corona ceca',
    aed: 'Dirham UAE',
    sek: 'Corona svedese',
    dkk: 'Corona danese',
    nok: 'Corona norvegese',
    gbp: 'Sterlina britannica',
    omr: 'Rial omanita',
  },
  routes: {
    venue: {
      index: 'Punto Vendita',
      create: 'Crea Punto Vendita',
      createSimple: 'Crea Punto Vendita',
      copyFoodcard: 'Copia foodcard',
      edit: 'Modifica Punto Vendita',
      panic: 'Impostazioni Panico',
      editSimple: 'Modifica Punto Vendita',
      verify: 'Verifica Punto Vendita',
      publish: 'Pubblica Punto Vendita',
      migrate: 'Migra Punto Vendita',
      sync: 'Sincronizza Punto Vendita',
      copy: 'Copia Punto Vendita',
    },
    screensaver: {
      index: 'Salvaschermo',
      create: 'Crea salvaschermo',
      edit: 'Modifica salvaschermo',
    },
    employeeNotification: {
      index: 'Notifica Dipendente',
      create: 'Crea Notifica Dipendente',
    },
    banner: {
      index: 'Banner',
      create: 'Crea banner',
      edit: 'Modifica banner',
    },
    venueLabel: {
      index: 'Etichetta Punto Vendita',
      create: 'Crea Etichetta Punto Vendita',
      edit: 'Modifica Etichetta Punto Vendita',
    },
    sepa: {
      index: 'Impostazioni SEPA',
    },
    productCombos: {
      index: 'Combinazioni prodotto',
    },
    promo: {
      index: 'Codici Promo',
      create: 'Crea Codice Promo',
      createTeedeli: 'Crea Codice Promo Teedeli',
      edit: 'Modifica Codice Promo',
      export: 'Esporta Codice Promo',
      exportTeedeli: 'Esporta Codice Promo Teedeli',
      disable: 'Disabilita Codici Promo',
      createMultiple: 'Crea Più Codici Promo',
    },
    cupCode: {
      index: 'Codici Bicchiere',
      create: 'Crea Codice Bicchiere',
      edit: 'Modifica Codice Bicchiere',
    },
    coupon: {
      index: 'Coupon (deprecato)',
      create: 'Crea Coupon',
      edit: 'Modifica Coupon',
      export: 'Esporta Coupon',
      disable: 'Disabilita Coupon',
      createMultiple: 'Crea Più Coupon',
    },
    maintenance: {
      index: 'Manutenzione',
    },
    provision: {
      index: 'Provvigione',
    },
    inventory: {
      index: 'Gestisci Inventario',
      create: 'Crea Inventario',
      edit: 'Modifica Inventario',
    },
    payment: {
      index: 'Pagamento',
    },
    home: {
      index: 'Home',
    },
    reporting: {
      index: 'Reportistica',
    },
    register: {
      index: 'Informazioni Franchisee',
      venue: 'Registra Punti Vendita',
      success: 'Registrazione Riuscita',
    },
    analytics: {
      index: 'Analytics',
    },
    sales: {
      index: 'Vendite',
    },
    salesOverview: {
      index: 'Panoramica Vendite',
    },
    receipt: {
      index: 'Ricevute',
    },
    eposJobs: {
      index: 'Lavori EPOS',
    },
    sanifairLogs: {
      index: 'Log Sanifair',
    },
    automatedReports: {
      index: 'Report Automatici',
      create: 'Crea Report Automatico',
    },
    billing: {
      index: 'Fatturazione',
    },
    userExport: {
      index: 'Esportazione utenti',
    },
    activityLogExport: {
      index: 'Log attività',
    },
    lightspeed: {
      index: 'Lightspeed',
      success: 'Autorizzazione riuscita',
      error: 'Autorizzazione fallita',
    },
    statistics: {
      index: 'Statistiche',
    },
    error: {
      index: 'Errore',
      notFound: '404 Pagina Non Trovata',
      forbidden: '401 Non Autorizzato',
    },
    user: {
      index: 'Utente',
      create: 'Crea Utente',
      edit: 'Modifica Utente',
      createSimple: 'Crea Utente',
      editSimple: 'Modifica Utente',
    },
    role: {
      index: 'Ruolo',
      create: 'Crea Ruolo',
      edit: 'Modifica Ruolo',
    },
    customerGroupProprty: {
      index: 'Proprietà Gruppo Clienti',
      create: 'Crea Proprietà Gruppo Clienti',
      edit: 'Modifica Proprietà Gruppo Clienti',
    },
    foodcard: {
      index: 'Importa Foodcard',
    },
    printer: {
      index: 'Stampante',
      edit: 'Modifica Stampante',
    },
    tag: {
      index: 'Etichetta',
      create: 'Crea Etichetta',
      edit: 'Modifica Etichetta',
    },
    information: {
      index: 'Informazioni',
      create: 'Crea Informazioni',
      edit: 'Modifica Informazioni',
    },
    constrain: {
      index: 'Gruppo Commerciale',
      create: 'Crea Gruppo Commerciale',
      edit: 'Modifica Gruppo Commerciale',
    },
    printGroups: {
      index: 'Gruppi di Stampanti',
      create: 'Crea Gruppi di Stampanti',
      edit: 'Modifica Gruppi di Stampanti',
    },
    dashboard: {
      index: 'Dashboard',
    },
    auditing: {
      index: 'Auditing',
    },
    enrollments: {
      index: 'Registrazioni',
    },
    table: {
      index: 'Tavolo',
      create: 'Crea Tavolo',
      edit: 'Modifica Tavolo',
    },
    category: {
      index: 'Categoria',
      create: 'Crea Categoria',
      edit: 'Modifica Categoria',
    },
    subscriptionCategories: {
      index: 'Categoria Abbonamento',
      create: 'Crea Categoria Abbonamento',
      edit: 'Modifica Categoria Abbonamento',
    },
    subscription: {
      index: 'Abbonamento',
      create: 'Crea Abbonamento',
      edit: 'Modifica Abbonamento',
    },
    membership: {
      index: 'Membership',
      create: 'Crea Membership',
      edit: 'Modifica Membership',
    },
    article: {
      index: 'Articolo',
      create: 'Crea Articolo',
      edit: 'Modifica Articolo',
      editSimple: 'Modifica Articolo',
    },
    articleManager: {
      index: 'Gestione Articoli',
    },
    recommendation: {
      index: 'Raccomandazione Carrello',
      create: 'Crea Raccomandazione Carrello',
      edit: 'Modifica Raccomandazione Carrello',
    },
    option: {
      index: 'Opzione',
      create: 'Crea Opzione',
      edit: 'Modifica Opzione',
      editSimple: 'Modifica Opzione',
    },
    customer: {
      index: 'Cliente',
      create: 'Crea Cliente',
      edit: 'Modifica Cliente',
      import: 'Importa Cliente',
    },
    translation: {
      index: 'Traduzione',
    },
    loyaltyPrograms: {
      index: 'Programmi Fedeltà',
      create: 'Crea Programma Fedeltà',
      edit: 'Modifica Programmi Fedeltà',
    },
    sync: {
      index: 'Sincronizzazione',
      create: 'Crea Sincronizzazione',
      upsell: 'Crea Upsell Sync',
    },
    aggregatorSyncs: {
      index: 'Sincronizzazioni',
    },
    posSync: {
      index: 'Sincronizzazione POS',
    },
    company: {
      index: 'Aziende',
      create: 'Crea Azienda',
      edit: 'Modifica Azienda',
    },
    ui: {
      banner: {
        index: 'Banner',
        create: 'Crea Banner',
        edit: 'Modifica Banner',
      },
      card: {
        index: 'Card',
        create: 'Crea Card',
        edit: 'Modifica Card',
      },
      slider: {
        index: 'Slider',
        create: 'Crea Slider',
        edit: 'Modifica Slider',
      },
    },
    campaign: {
      index: 'Campagne',
      create: 'Crea Campagna',
      edit: 'Modifica Campagna',
    },
    releases: {
      index: 'Versioni',
      create: 'Crea Versione',
      edit: 'Modifica Versione',
    },
    upsells: {
      index: 'Upsell',
    },
    depositRule: {
      index: 'Regole Cauzione',
      create: 'Crea Regola Cauzione',
      edit: 'Modifica Regola Cauzione',
    },
    healthCheck: {
      index: 'Healthcheck',
      create: 'Crea Healthcheck',
      edit: 'Modifica Healthcheck',
    },
    forgotPassword: 'Password Dimenticata',
    resetPassword: 'Reimposta Password',
  },
  weekdays: {
    monday: 'Lunedì',
    mondayShort: 'Lun',
    tuesday: 'Martedì',
    tuesdayShort: 'Mar',
    wednesday: 'Mercoledì',
    wednesdayShort: 'Mer',
    thursday: 'Giovedì',
    thursdayShort: 'Gio',
    friday: 'Venerdì',
    fridayShort: 'Ven',
    saturday: 'Sabato',
    saturdayShort: 'Sab',
    sunday: 'Domenica',
    sundayShort: 'Dom',
  },
  orderStatus: {
    none: 'Predefinito',
    created: 'Creato',
    in_preparation: 'In Preparazione',
    ready: 'Pronto',
    in_payment: 'In Pagamento',
    awaiting_confirmation: 'In Attesa di Conferma',
    done: 'Completato',
    failed: 'Fallito',
    validated: 'Validato',
    cancelled_by_waiter: 'Annullato dal Cameriere',
    cancelled_by_customer: 'Annullato dal Cliente',
  },
  checkoutIntegrationStatus: {
    sent: 'Inviato',
    received: 'Ricevuto',
    verified: 'Verificato',
    finalized: 'Finalizzato',
    rejected: 'Rifiutato',
    canceled: 'Annullato',
    postponed: 'Posticipato',
  },
  stockMode: {
    none: 'Disattivato',
    toggle: 'Attivato',
    disable_only: 'Disattiva solo articoli',
    enable_only: 'Attiva solo articoli',
  },
  mainCategories: {
    dish: 'Piatto',
    beverage: 'Bevanda',
    other: 'Altro',
  },
  autoReset: {
    none: 'Nessuno',
    morning: 'Mattina',
    noon: 'Mezzogiorno',
    evening: 'Sera',
    midnight: 'Mezzanotte',
  },
  customerGroups: {
    default: 'predefinito',
    defaultInPreparation: 'predefinito_in_preparazione',
    defaultWebApp: 'predefinito_app_web',
    subway: 'Subway',
    db: 'Deutsche Bahn',
    lunchroom: 'Mensa',
    weilands: 'Weilands',
    cinemaxx: 'Cinemaxx',
    fbf: 'Food By Friends',
    district: 'Distretto',
    slush: 'Slush',
    kochloeffel: 'Kochlöffel',
    immergruen: 'Immergrün',
    myMonza: 'MyMonza',
    subwayFr: 'Subway Francia',
    subwayLu: 'Subway Lussemburgo',
    subwayTerminal: 'Subway Terminale',
    aspasia: 'Aspasia',
    cotidiano: 'Cotidiano',
    bigburger: 'BigBurger',
    koos: 'KOOS',
    deanAndDavid: 'Dean and David',
    frittenwerk: 'Frittenwerk',
    purino: 'Purino',
    ottosBurger: 'Otto´s Burger',
    threeMensKebab: '3 Mens Kebab',
    perfectDay: 'Perfect Day',
    hausmanns: 'Hausmanns',
    doenerwerk: 'Dönerwerk',
    foodlounge: 'Foodlounge',
    mado: 'Mado',
    depot: 'Depot',
    nordsee: 'Nordsee',
    jamies: 'Jamies',
    burgerKing: 'Burger King',
    burgerKingD: 'Burger King D',
    atlantikFisch: 'Atlantik Fisch',
    moschmosch: 'Moschmosch',
    kamps: 'Kamps',
    coffeeFellows: 'Coffee Fellows',
    hofbrauhaus: 'Hofbrauhaus',
    saray: 'Saray',
    starbucks: 'Starbucks',
    dimatest: 'Dima Test',
    maloa: 'Maloa',
    werk5: 'Werk 5',
    epi: 'EPI',
    iamlove: 'IAMLOVE',
    beetsAndRoots: 'Beets and Roots',
    beetsAndRootsSecond: 'Beets and Roots 2',
    losteria: "L'Osteria",
    losteriaAt: "L'Osteria Austria",
    shiso: 'Shiso',
    snackElize: 'Snack Elize',
    tabilo: 'TUR RES',
    tabiloSim: 'TUR Simphony',
    turAbnahmeRes: 'TUR Abnahme RES',
    turAbnahmeSim: 'TUR Abnahme Sim',
    turAutohof: 'TUR Autohof',
    turAbnahmeAutohof: 'TUR Abnahme Autohof',
    turSegafredo: 'TUR Segafredo',
    effeGold: 'Effe & Gold',
    lacantine: 'La cantine',
    eam: 'Eam',
    naupaka: 'Naupaka',
    sportsbar: 'Sportsbar',
    cigkoftem: 'Cigkoftem',
    sushisupply: 'Sushi Supply',
    the_ash: 'The Ash',
    markthalle: 'Markthalle',
    sashimi: 'Sashimi',
    bonboncha: 'Bonboncha',
    hulala: 'Hulala',
    backwerk_schweiz: 'Backwerk Svizzera',
    backwerkCh: 'Backwerk CH',
    backfactory: 'Backfactory',
    teedeli: 'Teedeli',
    wohlfuhler: 'Wohlfuhler',
    asiaGourmet: 'Asia Gourmet',
    frittenwerkSecond: 'Frittenwerk 2',
    ricerepublic: 'RiceRepublic',
    goodbytz: 'Goodbytz',
    piratenBurger: 'Piraten Burger',
    tournesol: 'Tournesol',
    brezelKoenig: 'Brezelkönig',
    vincentVegan: 'Vincent Vegan',
    papais: 'Papais',
    theCup: 'The Cup',
    marseilleFoodMarket: 'Marseille Food Market',
    olearys: 'Olearys',
    iceland: 'Islanda',
    tableDot: 'Table Dot',
    sevenByBat: 'Seven by BAT',
    breakBurger: 'Break Burger',
    wok: 'Wok',
    oakberry: 'Oakberry',
    trz: 'TRZ',
    monkeyBurger: 'Monkey Burger',
    pastaFee: 'Pasta Fee',
    potatoe: 'Potatoe',
    pibose: 'Pibosa',
    shiangMing: 'Shiang Ming',
    antonAndAnni: 'Anton&Anni',
    kaisin: 'Kaisin',
    dunkin: 'Dunkin',
    sushiTomo: 'Sushi Tomo',
    spiga: 'SPIGA',
    rastpark: 'Euro Rastpark',
    ahoi: 'Ahoi',
    eatdoori: 'Eatdoori',
    burroBurro: 'Burro Burro',
    brammibalDonuts: 'Brammibal Donuts',
    milanoVice: 'Milano Vice',
    sspSliceIt: 'SSP Slice It',
    keladamsKebab: 'Keladams Kebab',
    autohof24: 'Autohof 24',
    reishauer: 'Reishauer',
    pastaLich: 'Pasta Lich',
    eintrachtFrankfurt: 'Eintracht Francoforte',
    topgolf: 'Topgolf',
    klausKebab: 'Klaus Kebab',
    josefs: 'Josefs',
    burritoCompany: 'Burrito Company',
    zeroKebab: 'Zero Kebab',
    nhasCityChicken: 'Nhas City Chicken',
    mrSha: 'Mr. Sha',
    bollwerk: 'Bollwerk',
    wyniger: 'Wyniger',
    burgerVision: 'Burger Vision',
    picklBurger: 'Pickl Burger',
    maisonMatcha: 'Maison Matcha',
    enriqueTomas: 'Enrique Tomas',
    versaillesCastle: 'Versailles Castle',
    randys: 'Randys',
    saz: 'Saz',
    hawaiianPokeBowls: 'Hawaiian Poke Bowls',
    luca: 'Luca',
    olearysNordic: "O'Learys Nordic",
    trattoriaTavolare: 'Trattoria Tavolare',
    carlsbergSportsBar: 'Carlsberg Sports Bar',
    bistro: 'Bistro',
    jomfruin: 'Jomfruin',
    rabbagast: 'Rabbagast',
    craftNDraft: 'Craft n Draft',
    herfra: 'Herfra',
    cafeRitazza: 'Cafe Ritazza',
    heineken: 'Heineken',
    laBoutique: 'La Boutique',
    vaerbitt: 'Vaerbitt',
    originalChicken: 'Original Chicken',
    tigerstaden: 'Tigerstaden',
    bjornsBackyard: 'Bjorns Backyard',
    burgerKingCh: 'Burger King CH',
    gelatoBar: 'Gelato Bar',
    sspVincentVegan: 'SSP Vincent Vegan',
    elKiosko: 'El Kiosko',
    camden: 'Camden',
    pizzaHut: 'Pizza Hut',
    spareRib: 'Spare Rib',
    lucullus: 'Lucullus',
    bonbird: 'Bonbird',
    sspPizzaHut: 'SSP Pizza Hut',
    elevenBar: '11 Bar',
    theKissingGates: 'The Kissing Gates',
    gambrinus: 'Gambrinus',
    tabernnus: 'Tabernnus',
    jimis: 'Jimis',
    hensslerAtHome: 'Henssler At Home',
    dailyPizza: 'Daily Pizza',
    hunterBar: 'Hunter Bar',
    mogaTee: 'Moga Tee',
    grauholz: 'Grauholz',
    figlmueller: 'Figlmüller',
    dominosSwitzerland: 'Dominos Pizza CH',
    wildChildCoffee: 'Wild Child Coffee',
    asFoodCompany: 'As Food Company',
    smashKoenig: 'Smash Koenig',
    schurter: 'Schurter',
    dirtyPatty: 'Dirty Patty',
    captainHook: 'Captain Hook',
    ingerslevs: 'Ingerslevs',
    thaqiCafeNuernberg: 'Thaqi Cafe Nürnberg',
    aramarkAsianBistrotConcept: 'Aramark Asian Bistrot Concept',
    theBab: 'The Bab',
    locoChicken: 'Loco Chicken',
    eatery77: 'Eatery 77',
    beshle: 'Beshle',
    feasty: 'Feasty',
    kantine11: 'Kantine 11',
    foodBrother: 'Food Brother',
    pastalich: 'Pastalich',
    zagros: 'Zagros',
  },
  deliverableOrderTypes: {
    foodspot: 'Foodspot',
    delivery: 'Consegna',
  },
  error: {
    notFound: 'Spiacenti, la pagina non è stata trovata.',
    forbidden: 'Vietato.',
    goHome: "Torna all'inizio",
    forbiddenText: 'Non autorizzato. Non sei autorizzato a visualizzare questa pagina.',
    notFoundText: 'La pagina che stai cercando non è stata trovata.',
  },
  foodcard: {
    index: 'Gestisci Foodcard',
    export_csv: 'Esporta Foodcard (*.csv)',
    export_csv_de: 'DE Esporta Foodcard (*.csv)',
    import: 'Importa Foodcard',
    importCvs: 'Importa foodcard (*.csv)',
    importNutritionCsv: 'Importa valori nutrizionali (*.csv)',
    export_xlsx_de: 'DE Esporta Foodcard (*.xlsx)',
    importCvsWithArticleInfo: 'Importa informazioni articoli (*.csv)',
  },
  home: {
    index: 'Home',
    welcome: 'Benvenuto!',
  },
  tag: {
    index: 'Gestisci Etichette',
    overview: 'Panoramica',
    add: 'Aggiungi Etichetta',
    empty:
      'Sembra che tu non abbia ancora aggiunto nessuna etichetta. Crea la tua prima etichetta per assegnarla ai tuoi articoli e opzioni.',
    form: {
      name: 'Nome',
      identifier: 'Identificatore',
      sort: 'Ordine',
      recommendationTag: 'Etichetta Raccomandazione',
    },
    table: {
      name: 'Nome',
      identifier: 'Identificatore',
      sort: 'Ordine',
      recommendationTag: 'Etichetta Raccomandazione',
    },
  },
  depositRule: {
    index: 'Gestisci Regole Cauzione',
    overview: 'Panoramica',
    add: 'Aggiungi Regola Cauzione',
    empty: 'Sembra che tu non abbia ancora aggiunto nessuna regola cauzione. Crea la tua prima regola cauzione.',
    form: {
      priority: 'Priorità',
      deposit: 'Cauzione',
      startedAt: 'Da',
      endedAt: 'A',
    },
    table: {
      priority: 'Priorità',
      deposit: 'Cauzione',
      startedAt: 'Da',
      endedAt: 'A',
    },
  },
  information: {
    index: 'Gestisci Informazioni',
    overview: 'Panoramica',
    add: 'Aggiungi Informazioni',
    edit: 'Modifica Informazioni',
    addAction: 'Aggiungi Azione',
    removeAction: 'Rimuovi Azione',
    actions: 'Azioni',
    empty:
      'Sembra che tu non abbia ancora aggiunto nessuna informazione. Crea la tua prima informazione per informare i clienti su eventi e promozioni imminenti.',
    actionTypes: {
      primary: 'Primario',
      secondary: 'Secondario',
      cancel: 'Annulla',
    },
    form: {
      image: 'Immagine',
      title: 'Titolo',
      from: 'Da',
      to: 'A',
      description: 'Descrizione',
      url: 'Url',
      action: 'Azione',
      actionType: 'Tipo Azione',
      actionValue: 'Valore Azione',
      actionHtmlContent: 'Contenuto HTML',
      actionName: 'Nome Azione',
    },
    table: {
      title: 'Titolo',
      description: 'Descrizione',
      from: 'Da',
      to: 'A',
      url: 'Url',
    },
  },
  role: {
    index: 'Gestisci Ruoli',
    overview: 'Panoramica',
    create: 'Crea Ruolo',
    edit: 'Modifica Ruolo',
    copy: 'Copia Ruolo',
    empty:
      'Sembra che tu non abbia ancora creato nessun ruolo. Crea il tuo primo ruolo per fornire accesso granulare agli utenti.',
    help: 'Attenzione! Modifica un ruolo solo se sei assolutamente sicuro di ciò che stai facendo. Nota anche che i ruoli di sistema non possono essere modificati.',
    add: 'Aggiungi Ruolo',
    table: {
      name: 'Nome',
      slug: 'Slug',
      isSystem: 'Ruolo di Sistema',
      permissions: 'Permessi',
    },
    form: {
      name: 'Nome',
      slug: 'Slug (identificatore univoco)',
      isSystem: 'Ruolo di sistema (se attivo, il ruolo non può essere modificato.)',
      permissions: 'Permessi',
    },
    notification: {
      roleCopyStarted:
        'Il processo di copia del ruolo è iniziato. Verrai reindirizzato alla pagina di Creazione Ruolo con dati precompilati. Applica eventuali modifiche se necessario e fai clic su Salva.',
      roleCopyFailed: 'Il processo di copia del ruolo non è riuscito. Riprova.',
    },
  },
  customerGroupProprty: {
    index: 'Gestisci Proprietà Gruppo Clienti',
    overview: 'Panoramica',
    create: 'Crea Proprietà Gruppo Clienti',
    edit: 'Modifica Proprietà Gruppo Clienti',
    add: 'Aggiungi Proprietà Gruppo Clienti',
    importTemplate: 'Importa Modello Fattura Cliente',
    table: {
      name: 'Nome',
      template: 'Modello Fattura',
      defaultOrderStatus: 'Stato Ordine Predefinito',
      initialOrderStatusStandard: 'Stato Ordine Iniziale Standard',
      initialOrderStatusTerminal: 'Stato Ordine Iniziale Terminale',
    },
    form: {
      customerGroupName: 'Nome',
      getDefaultOrderStatus: 'Stato Ordine Predefinito',
      getInitialOrderStatusStandard: 'Stato Ordine Iniziale Standard',
      getInitialOrderStatusTerminal: 'Stato Ordine Iniziale Terminale',
      getInitialOrderStatusVirtual: 'Stato Ordine Iniziale Virtuale',
    },
  },
  venueLabel: {
    index: 'Gestisci Etichette Punto Vendita',
    overview: 'Panoramica',
    create: 'Crea Etichetta Punto Vendita',
    edit: 'Modifica Etichetta Punto Vendita',
    empty: 'Sembra che tu non abbia ancora creato nessuna etichetta punto vendita.',
    add: 'Aggiungi Etichetta',
    table: {
      name: 'Nome',
      slug: 'Slug',
      venues: 'Punti Vendita',
    },
    form: {
      name: 'Nome',
      image: 'Immagine',
      slug: 'Slug (identificatore univoco)',
      venues: 'Punti Vendita',
      visibleTo: 'Visibile a Punti Vendita',
    },
  },
  recommendation: {
    index: 'Raccomandazione Carrello',
    create: 'Crea Raccomandazione Carrello',
    edit: 'Modifica Raccomandazione Carrello',
    overview: 'Panoramica',
    score: 'Punteggio',
    scoreMatrix: 'Matrice Punteggio',
    scoreMatrixNotFound: 'Matrice Punteggio non trovata',
    best: 'Migliore',
    worst: 'Peggiore',
  },
  user: {
    index: 'Gestisci Utenti',
    overview: 'Panoramica',
    create: 'Crea Utente',
    adminCreateWarning: 'Attenzione: stai tentando di creare un utente con ruolo admin.',
    adminCreateConfirm: 'Sei davvero sicuro di voler creare un utente admin?',
    changePassword: 'Cambia Password',
    help: 'Attenzione! Modifica un utente solo se sei assolutamente sicuro di ciò che stai facendo. Altrimenti un utente potrebbe non essere in grado di accedere.',
    edit: 'Modifica Utente',
    add: 'Aggiungi Utente',
    table: {
      name: 'Nome',
      email: 'E-Mail',
      code: 'Codice',
      venues: 'Punti Vendita',
      role: 'Ruolo',
    },
    form: {
      name: 'Nome',
      customerGroup: 'Gruppo Clienti',
      linkedCustomerGroup: 'Gruppo Clienti Collegato',
      email: 'E-Mail',
      password: 'Password',
      passwordConfirmation: 'Conferma Password',
      venues: 'Punti Vendita',
      venueLabels: 'Etichette Punto Vendita',
      role: 'Ruolo',
    },
  },
  printer: {
    index: 'Gestisci Stampanti',
    overview: 'Panoramica',
    edit: 'Modifica Stampante',
    customerGroup: 'Gruppo Clienti',
    empty: 'Sembra che non ci siano ancora stampanti.',
    table: {
      name: 'Nome',
      articleCount: 'Numero di Articoli',
      venue: 'Punto Vendita',
      startedAt: 'Iniziato il',
      activated: 'Attivato',
      lastSignal: 'Ultimo Segnale',
      latestActivity: 'Ultima Attività',
      restart: 'Riavvia',
      restartInProgress: 'Riavvio in corso...',
      order: 'Ordine',
    },
    form: {
      articles: 'Articoli',
      name: 'Nome',
    },
  },
  customer: {
    index: 'Gestisci Clienti',
    overview: 'Panoramica',
    edit: 'Modifica Cliente',
    create: 'Crea Cliente',
    add: 'Aggiungi Cliente',
    import: 'Importa Cliente',
    empty: 'Sembra che tu non abbia ancora aggiunto nessun cliente. Crea il tuo primo cliente.',
    table: {
      userUid: 'UID Utente',
      name: 'Nome',
      email: 'E-Mail',
      qr: 'Codice QR',
    },
    form: {
      email: 'E-Mail',
      gender: 'Genere',
      name: 'Nome Completo',
      city: 'Città',
      street: 'Via',
      number: 'Numero',
      postalCode: 'Codice Postale',
    },
  },
  constrain: {
    index: 'Gestisci Gruppi Commerciali',
    overview: 'Panoramica',
    add: 'Aggiungi Gruppo Commerciale',
    empty:
      'Sembra che tu non abbia ancora aggiunto nessun gruppo commerciale. Crea il tuo primo gruppo commerciale per assegnarlo ai tuoi articoli.',
    form: {
      name: 'Nome',
      identifier: 'Identificatore',
      active: 'Attivo',
    },
    table: {
      name: 'Nome',
      identifier: 'Identificatore',
      active: 'Attivo',
    },
  },
  printGroups: {
    index: 'Gestisci Gruppi di Stampanti',
    overview: 'Panoramica',
    add: 'Aggiungi Gruppi di Stampanti',
    empty:
      'Sembra che tu non abbia ancora aggiunto nessun Gruppo di Stampanti. Crea il tuo primo Gruppo di Stampanti per assegnarlo ai tuoi articoli.',
    form: {
      name: 'Nome',
      identifier: 'Identificatore',
      active: 'Attivo',
    },
    table: {
      name: 'Nome',
      identifier: 'Identificatore',
      active: 'Attivo',
    },
  },
  languages: {
    de: 'Tedesco',
    en: 'Inglese',
    fr: 'Francese',
    nl: 'Olandese',
    it: 'Italiano',
    pl: 'Polacco',
    es: 'Spagnolo',
    tr: 'Turco',
    zh: 'Cinese',
    ru: 'Russo',
    da: 'Danese',
    ja: 'Giapponese',
    is: 'Islandese',
    pt: 'Portoghese',
    cz: 'Ceco (NON USARE)',
    cs: 'Ceco',
    ar: 'Arabo',
    el: 'Greco',
    ko: 'Coreano',
    th: 'Tailandese',
    vi: 'Vietnamita',
    hi: 'Hindi',
    ur: 'Urdu',
    tl: 'Tagalog',
    id: 'Indonesiano',
    no: 'Norvegese',
    sv: 'Svedese',
    lt: 'Lituano',
    fi: 'Finlandese',
  },
  legalForms: {
    ag: 'AG',
    gmbh: 'GmbH',
    ltd: 'UG',
    kg: 'KG',
    pe: 'Impresa individuale',
    other: 'Altro',
    sa: 'SA',
    sarl: 'SARL',
    eurl: 'EURL',
    sas: 'SAS',
    autres: 'ALTRI',
    se: 'SE',
    seCoKg: 'SE & Co. KG',
  },
  periods: {
    daily: 'Giornaliero',
    weekly: 'Settimanale',
    monthly: 'Mensile',
    never: 'Mai',
  },
  locTypes: {
    bar: 'Bar',
    club: 'Club',
    restaurant: 'Ristorante',
    db: 'Deutsche Bahn',
    cinema: 'Cinema',
    other: 'Altro',
  },
  paymentTypes: {
    cc: 'Carta di Credito',
    pp: 'PayPal',
    sepa: 'SEPA',
    sb: 'Sofort Banking',
    bankTransfer: 'Bonifico Bancario',
    paypal: 'PayPal',
    cash: 'Contanti',
    credit_card: 'Carta di Credito',
    balance: 'Saldo',
    pos: 'POS',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    sofortbanking: 'Sofort Banking',
    wallee: 'Wallee',
    postfinance: 'PostFinance',
    postfinance_card: 'PostFinance Card',
    reka: 'Reka',
    twint: 'Twint',
    luncheck: 'Luncheck',
    boncard: 'Boncard',
    alipay: 'Alipay',
    wechat: 'WeChat Pay',
    worldline: 'Worldline',
    worldline_raw: 'Worldline (Raw)',
    tac: 'TAC',
    ccv: 'CCV',
    zero_payment: 'Pagamento Zero',
    wolt: 'Wolt',
    ec: 'EC',
    girocard: 'Girocard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    visa: 'Visa',
    visa_e: 'Visa Electron',
    vpay: 'V PAY',
    jcb: 'JCB',
    maestro: 'Maestro',
    other: 'Altro',
    vr_sepa: 'VR SEPA',
    bank_transfer: 'Bonifico Bancario',
    diners: 'Diners Club',
    discover: 'Discover',
    subsidy: 'Sussidio',
    piggy_gift_card: 'Piggy Gift Card',
    piggy_prepaid_balance: 'Piggy Prepaid Balance',
    miles_and_more: 'Miles & More',
    kost_card: 'Carta KOST',
    worldline_mobile_apple_pay: 'Worldline Mobile Apple Pay',
    worldline_mobile_credit_card: 'Worldline Mobile Carta di Credito',
    worldline_mobile_google_pay: 'Worldline Mobile Google Pay',
    worldline_apple_pay: 'Worldline Apple Pay',
    worldline_credit_card: 'Worldline Carta di Credito',
    worldline_google_pay: 'Worldline Google Pay',
    ideal: 'iDEAL',
    meal_voucher_fr: 'Buono Pasto (FR)',
    bon_bon_gift_card: 'Bon Bon Gift Card',
    deliveroo: 'Deliveroo',
    swish: 'Swish',
    vipps: 'Vipps',
    mobile_pay: 'Mobile Pay',
    dankort: 'Dankort',
    maxxvend: 'MAXXvend',
  },
  nav: {
    dashboard: 'Dashboard',
    auditing: 'Auditing',
    enrollments: 'Registrazioni',
    foodcard: 'Foodcard',
    customer: 'Clienti',
    screensaver: 'Salvaschermo',
    venue: 'Punti Vendita',
    venueLabel: 'Etichette Punto Vendita',
    productCombos: 'Combinazioni Prodotto',
    payment: 'Pagamenti',
    user: 'Utente',
    table: 'Tavoli',
    tag: 'Etichette',
    information: 'Informazioni',
    sales: 'Vendite',
    salesOverview: 'Panoramica Vendite',
    printer: 'Stampante',
    translation: 'Traduzione',
    tradegroup: 'Gruppi Commerciali',
    printGroups: 'Gruppi di Stampanti',
    provision: 'Provvigione',
    inventory: 'Inventario',
    statistic: 'Statistiche',
    analytic: 'Analytics',
    receipts: 'Ricevute',
    billing: 'Fatturazione',
    userExport: 'Esportazione utenti',
    selectVenue: 'Seleziona punto vendita',
    category: 'Categorie',
    subscriptionCategories: 'Categoria Abbonamento',
    subscription: 'Abbonamento',
    membership: 'Livello membership',
    article: 'Articoli',
    articleManager: 'Visibilità Articoli e Opzioni',
    recommendations: 'Raccomandazioni',
    option: 'Opzioni',
    reporting: 'Reportistica',
    import: 'Importa',
    role: 'Ruolo',
    sepa: 'SEPA',
    maintenance: 'Manutenzione',
    promo: 'Codici Promo',
    banner: 'Banner',
    tips: 'Mance',
    eposJobs: 'Lavori EPOS',
    automatedReport: 'Report Automatici',
    coupon: 'Coupon (deprecato)',
    employeeNotification: 'Notifica Dipendente',
    loyaltyPrograms: 'Programma Fedeltà',
    seasonPass: 'Season Pass',
    automatedReports: 'Report Automatici',
    customerGroupProprty: 'Gruppo Clienti',
    sanifairLogs: 'Log Sanifair',
    cupCode: 'Codici bicchiere',
    activityLogExport: 'Esportazione Log Attività',
    sync: 'Sincronizzazione',
    aggregatorSyncs: 'Sincronizzazione Aggregatore',
    posSync: 'Sincronizzazione POS',
    company: 'Aziende',
    promocodesAndLoyalty: 'Fedeltà',
    customerInfo: 'Info cliente',
    other: 'Altro',
    finances: 'Finanze',
    analytics: 'Analytics',
    syncAndLogs: 'Sincronizzazione e Log',
    uiComponents: 'Componenti UI',
    uiSlides: 'Diapositive',
    uiSlider: 'Slider',
    uiCard: 'Card',
    uiBanner: 'Banner',
    campaigns: 'Campagne',
    releases: 'Versioni',
    upsell: 'Upsell',
    depositRule: 'Regole Cauzione',
    healthCheck: 'Healthcheck',
  },
  auth: {
    logout: 'Esci',
    login: 'Accedi',
    forgotPassword: 'Password Dimenticata',
    forgotPasswordHint: 'Inserisci la tua e-mail e fai clic su reimposta password.',
    resetPassword: 'Reimposta Password',
    reset: 'Reimposta Password',
    security: 'Sicurezza account',
    form: {
      password: 'Password',
      passwordHint:
        'La password deve contenere almeno 8 caratteri, 1 lettera maiuscola e 1 numero o carattere speciale.',
      passwordConfirmation: 'Conferma Password',
      email: 'Email',
      otp: 'Codice monouso',
    },
    mfaModal: {
      title: 'Approvazione richiesta',
      description: 'Inserisci il tuo codice MFA',
    },
    accountSecurity: {
      title: 'Sicurezza account',
      mfa: {
        title: 'Autenticazione multi-fattore (MFA)',
        description:
          "L'autenticazione multi-fattore aggiunge un ulteriore livello di sicurezza al tuo account richiedendo più della semplice password per l'accesso e le funzioni critiche.",
        setup: 'Configura app Authenticator',
        scan: 'Scannerizza il codice QR con la tua app Authenticator.',
        enterCode:
          "Dopo aver scannerizzato il codice QR, l'app ti mostrerà un codice. Inserisci questo codice qui sotto.",
        enterCodeShort: 'Inserisci il tuo codice MFA:',
        backupCodesTitle: 'Codici di backup',
        backupCodesExplanation:
          "Se l'autenticazione multifattore è attiva e perdi il tuo dispositivo, avrai bisogno dei codici di backup per accedere al tuo account Lemin.",
        backupCodesDanger:
          "Senza codici di backup, dovrai contattare il nostro supporto e fornire la prova appropriata affinché il tuo account Lemin possa essere riattivato. <br/><br/> Ti consigliamo di scaricare o copiare i codici di backup e di conservarli in un luogo sicuro. Ogni codice di backup è valido solo una volta e verrà rimosso dopo l'uso.",
        copy: 'Copia',
        download: 'Scarica',
        print: 'Stampa',
        status: 'Stato',
        active: 'Attivo',
        notActive: 'Non attivo',
        deactivate: 'Disattiva',
        showBackupCodes: 'Mostra codici di backup',
        regenerateBackupCodes: 'Rigenera codici di backup',
        deactivateMFATitle: 'Disattiva autenticazione multi-fattore',
        deactivateMFADanger:
          "Per utilizzare nuovamente l'autenticazione multi-fattore, devi configurarla di nuovo. I codici di backup esistenti verranno eliminati dopo la disattivazione. <br/><br/>Sei sicuro di voler continuare?",
      },
    },
    notification: {
      forgotPassword:
        "Se abbiamo trovato la tua e-mail nel nostro sistema, ti invieremo un'email con un link per reimpostare la password",
      resetPassword: 'La tua password è stata reimpostata.',
      forbidden: 'Non hai il permesso di visualizzare questa pagina.',
      login: "Hai effettuato l'accesso con successo.",
      logout: 'Hai effettuato il logout con successo.',
      resetPasswordError: 'Il tuo token non è stato trovato o è scaduto.',
      invalidMFACode: 'Il codice MFA non è valido.',
    },
  },
  maintenance: {
    index: 'Manutenzione',
    status: 'Stato manutenzione',
    enable: 'Attiva Manutenzione',
    disable: 'Disattiva Manutenzione',
    enabled: 'Il sistema è attualmente in modalità di manutenzione. Alcuni servizi potrebbero non essere disponibili.',
    disabled: 'Tutti i sistemi funzionano correttamente.',
  },
  register: {
    index: 'Registrazione',
    account: 'Account',
    register: 'Registrati',
    success: 'Registrazione Riuscita',
    addVenue: 'Aggiungi Punto Vendita',
    removeVenue: 'Rimuovi Punto Vendita',
    venue: 'Crea Punti Vendita',
    documentInfo:
      'Compila i seguenti dati per generare il tuo imprinting, termini e condizioni e politica sulla privacy per il tuo negozio online. Questi documenti sono necessari.',
    successText:
      'La tua registrazione è riuscita. Ti informeremo via email quando i tuoi punti vendita saranno creati.',
    location: 'Dettagli Posizione',
    invoiceReceiver: 'Destinatario Fattura',
    dialog: {
      venue: 'Vuoi creare un punto vendita? Se fai clic su no, puoi farlo in un secondo momento.',
    },
    form: {
      venue: 'Punto Vendita',
      name: 'Nome Completo',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      email: 'E-Mail',
      password: 'Password (min. 6)',
      passwordHint:
        'La password deve contenere almeno 8 caratteri, 1 lettera maiuscola e 1 numero o carattere speciale.',
      passwordConfirmation: 'Conferma Password (min. 6)',
      privacy: 'Accetto le Normative sulla Protezione dei Dati',
      privacyLink: 'Normative sulla Protezione dei Dati',
    },
    notification: {
      venue:
        'Il tuo nuovo Punto Vendita verrà aggiunto in pochi minuti. Effettua il logout e il login tra 3 minuti per vedere e modificare il tuo nuovo punto vendita.',
    },
  },
  article: {
    index: 'Gestisci Articoli',
    create: 'Crea un nuovo Articolo',
    edit: 'Modifica Articolo',
    copy: 'Copia Articolo',
    testFoodcard: 'Test foodcard',
    add: 'Aggiungi Articolo',
    availability: 'Disponibilità',
    overview: 'Panoramica',
    selectArticle: 'Seleziona Articolo',
    selectCategory: 'Seleziona Categoria',
    general: 'Generale',
    prices: 'Prezzi',
    visibility: 'Visibile',
    meta: 'Meta',
    measurement: 'Misurazione',
    media: 'Media',
    options: 'Opzioni',
    displayPrices: 'Mostra Prezzi',
    mappings: 'Mapping Articoli',
    requirements: 'Requisiti Articolo',
    nutritions: 'Valori nutrizionali articolo',
    defaults: 'Predefiniti Articolo',
    recommendations: 'Raccomandazioni Articolo',
    depArticles: 'Articoli',
    availableHours: 'Orari Disponibili',
    addGroupDependency: 'Aggiungi Dipendenza',
    addGroupReverseDependency: 'Aggiungi Dipendenze Inverse',
    addMappingArticle: 'Aggiungi Mapping Articolo',
    addDepArticles: 'Aggiungi Articoli Dipendenti',
    addReverseDepArticles: 'Aggiungi Articoli Dipendenti Inversi',
    dependencies: 'Dipendenze',
    reverseDependencies: 'Dipendenze inverse',
    addDefault: 'Aggiungi Predefinito',
    split: 'Dividi',
    standardPrices: 'Prezzi Standard',
    preorderPrices: 'Prezzi Preordine',
    terminalPrices: 'Prezzi Terminale',
    standardAvailability: 'Disponibilità Standard',
    terminalAvailability: 'Disponibilità Terminale',
    preorderAvailability: 'Disponibilità Preordine',
    priceLockByType: 'Blocco prezzi per tipo di ordine (il blocco prezzi generale ha la precedenza)',
    webAvailability: 'Disponibilità Web',
    cateringAvailability: 'Disponibilità Catering',
    noVisibleArticlesNotice: 'Spiacenti! Questo gruppo di opzioni non ha articoli visibili.',
    addRecommendation: 'Aggiungi Raccomandazione',
    price: 'Prezzo',
    priceLowToHigh: "Dal basso all'alto",
    priceHighToLow: "Dall'alto al basso",
    visible: 'Visibile',
    hide: 'Nascondi',
    fontColor: 'Colore Carattere',
    styleOption: 'Opzioni Stile',
    borderColor: 'Colore Bordo',
    backgroundColor: 'Colore Sfondo',
    style: 'Stili',
    loyaltyOptions: 'Opzioni Fedeltà',
    openingHours: 'Orari di Apertura',
    manufacturer: 'Produttore',
    ingredients: 'Ingredienti',
    dimension: 'Dimensioni',
    weightDetails: 'Dettagli Peso',
    seeOriginal: 'Vedi articolo originale',
    displayIdentifiersOfOptions: 'Mostra identificatori delle opzioni',
    tagsOfArticle: "Etichette dell'articolo",
    helloTess: {
      hellotessApiBaseUrl: 'URL api helloTESS!',
      hellotessApiKey: 'Chiave api helloTESS!',
      success: 'Foodcard importata',
    },
    gastrofix: {
      gastrofixBusinessUnit: 'Business Unit',
      gastrofixApiKey: 'Chiave api Gastrofix',
      gastrofixImportLanguage: 'Lingua Foodcard',
      success: 'Foodcard importata',
    },
    simphony: {
      orgShortName: 'Identificatore/Nome Breve Organizzazione',
      locRef: 'Identificatore Posizione',
      rvcRef: 'Identificatore Centro Ricavi',
      serviceUrl: 'URL Servizio',
      importLanguage: 'Lingua Foodcard',
      success: 'Foodcard importata',
    },
    deliverect: {
      account: 'ID Account Cliente Deliverect',
      menu: 'ID Menu',
      importLanguage: 'Lingua Foodcard',
      success: 'Foodcard importata',
    },
    generalImport: {
      checkoutIntegration: 'Foodcard',
    },
    tabs: {
      general: 'Generale',
      media: 'Media',
      meta: 'Meta',
      options: 'Opzioni',
      prices: 'Prezzi',
      displayPrices: 'Mostra Prezzi',
      availableHours: 'Orari Disponibili',
      availability: 'Disponibilità',
      allergens_and_additives: 'Allergeni e Additivi',
      nutritions: 'Valori nutrizionali',
      features: 'Caratteristiche',
      style: 'Stili',
      wolt: 'Wolt',
      uberEats: 'Uber-Eats',
      jet: 'Jet',
      deliveroo: 'Deliveroo',
      visibility: 'Visibilità',
    },
    table: {
      name: 'Nome',
      stock: 'Magazzino',
      price: 'Prezzo',
      active: 'Attivo',
      assets: 'Immagine',
      internalNote: 'Nota Interna',
      internalName: 'Nome Interno',
      category: 'Categoria',
      isControlArticle: 'Articolo di Controllo',
      availableHours: 'Orari Disponibili',
      categoryAvailableHours: 'Orari Disponibili Categoria',
      icon: 'Icona',
      banner: 'Banner',
      description: 'Descrizione',
      number: 'Numero',
      sortOrder: 'Ordine',
      gtin: 'GTIN',
      visible: 'Visibile',
      rowsPerPage: 'Righe per Pagina',
      externalId: 'ID Esterno',
      preorderDeliveryPrice: 'Prezzo Consegna Preordine',
      preorderTakeAwayPrice: 'Prezzo TakeAway Preordine',
      terminalTakeAwayPrice: 'Prezzo TakeAway Terminale',
      terminalInsidePrice: 'Prezzo Interno Terminale',
      tags: 'Etichette',
      taxTakeaway: 'IVA Takeaway',
      taxInside: 'IVA Interno',
      uber: 'Uber-Eats',
      wolt: 'Wolt',
      jet: 'Jet',
      uberEatsTakeawayEnabled: 'Uber Eats Takeaway Disponibile',
      uberEatsDeliveryEnabled: 'Uber Eats Consegna Disponibile',
      woltVisibility: 'Visibilità Wolt',
      woltActive: 'Wolt Attivo',
      jetTakeawayEnabled: 'Jet Takeaway Disponibile',
      jetDeliveryEnabled: 'Jet Consegna Disponibile',
    },
    copyDialog: {
      sourceCategory: 'Categoria Sorgente',
      targetCategory: 'Categoria Destinazione',
      articles: 'Articoli',
      venue: 'Seleziona Punto Vendita',
      success: 'Articolo(i) copiato(i)',
    },
    testFoodcardModal: {
      chunkSize: 'Numero di articoli per ordine',
      success: 'Il test della foodcard è stato avviato con successo.',
      error: 'Impossibile avviare il test della foodcard.',
    },
    form: {
      name: 'Nome',
      internalName: 'Nome Interno',
      description: 'Descrizione',
      price: 'Prezzo',
      prices: 'Prezzi',
      type: 'Tipo',
      value: 'Valore',
      emailDomain: 'Dominio email',
      bannerVideo: 'Video',
      kostPrice: 'Prezzo KOST',
      maxxvendPrice: 'Prezzo MAXXvend',
      dndCompany: 'Azienda DND',
      min: 'Min.',
      max: 'Max.',
      standardPrice: 'Prezzo Standard',
      insidePrice: 'Prezzo Interno',
      enabledInFoodcard: "Attivo (se non attivo, l'elemento non verrà aggiunto al menu Wolt)",
      deliveryPrice: 'Prezzo Consegna',
      takeAwayPrice: 'Prezzo Take Away',
      replacesMainArticle: 'Sostituisce Articolo Principale',
      gtin: 'GTIN (Global Trade Identifier Number)',
      externalId: 'ID Esterno',
      internalNote: 'Nota Interna',
      preparationTime: 'Tempo di Preparazione (in minuti)',
      plu: 'PLU',
      standardAvailability: 'Disponibile',
      insideAvailability: 'Disponibile interno',
      takeAwayAvailability: 'Disponibile per take away',
      deliveryAvailability: 'Disponibile per consegna',
      webAvailability: 'Disponibile',
      stock: 'Magazzino',
      image: 'Immagine',
      banner: 'Banner',
      icon: 'Icona',
      active: 'Attivo',
      tags: 'Etichette',
      group: 'Gruppo Opzioni',
      mainRecommendations: 'Raccomandazioni Principali',
      priceIsLocked: 'Prezzo Bloccato (tutti)',
      isNoticeable: 'Notevole',
      isControlArticle: 'Articolo di Controllo',
      shortDescription: 'Breve Descrizione',
      articles: 'Articoli',
      article: 'Articolo',
      visible: 'Visibile',
      printerSort: 'Ordine Stampante',
      quantity: 'Quantità',
      constrains: 'Gruppi Commerciali',
      printGroups: 'Gruppi di Stampanti',
      unit: 'Unità',
      amount: 'Importo',
      rateable: 'Valutabile',
      taxInside: 'IVA Interno',
      taxTakeaway: 'IVA Takeaway',
      takeaway: 'Takeaway',
      delivery: 'Consegna',
      inside: 'Interno',
      displayPrice: 'Mostra Prezzo',
      referencePrice: 'Prezzo di Riferimento',
      referencePriceHint:
        'Prezzo di vendita normale dell\'articolo. Per gli articoli in offerta, il campo "Prezzo" indica il prezzo scontato: inserisci qui il prezzo normale in modo che il prezzo originale e lo sconto vengano visualizzati correttamente.',
      isPrintable: 'Stampabile',
      isRateable: 'Valutabile',
      info: 'Info',
      sort: 'Ordine',
      mappedArticle: 'Articolo Mappato',
      code: 'Codice',
      category: 'Categoria',
      number: 'Numero',
      deposit: 'Cauzione',
      fsk: 'FSK',
      alcoholPercentage: 'Alcol (in Percentuale)',
      caffeineMg: 'Caffeina (mg)',
      main: 'Articolo Principale',
      kcal: 'Kcal',
      options: 'Opzioni',
      optionGroup: 'Gruppo Opzioni',
      newName: 'Nuovo Nome',
      availableDateStart: 'Data Inizio Disponibilità',
      availableDateEnd: 'Data Fine Disponibilità',
      maxItemsPerCart: 'Max. Articoli per Carrello',
      articleRelativeBrand: 'Marca',
      loyaltyId: 'ID Fedeltà',
      isPiggyLoyalty: 'Fedeltà Piggy',
      redeemableAtCheckoutOnly: 'Riscattabile',
      piggyPointsNeeded: 'Punti Piggy Necessari (deprecato)',
      piggyRewardUuid: 'UUID Ricompensa Piggy',
      requiredLoyaltyPoints: 'Punti fedeltà richiesti per il riscatto',
      address: 'Indirizzo',
      country: 'Paese',
      visibility: 'Visibilità',
      company: 'Azienda',
      height: 'Altezza (cm)',
      width: 'Larghezza (cm)',
      length: 'Lunghezza (cm)',
      weight: 'Peso (g)',
      foodInstructions: 'Istruzioni Alimentari',
      storageInstructions: 'Istruzioni Conservazione',
      providerImage: 'Immagine',
      priceLockByType: {
        standard: 'Standard',
        terminal: 'Terminale',
        preorder: 'Preordine',
        inside: 'Prezzo bloccato per interno',
        takeAway: 'Prezzo bloccato per take away',
        delivery: 'Prezzo bloccato per consegna',
      },
      allergenes: {
        allergenes: 'Allergeni',
        cerealsWithGluten: 'Cereali contenenti glutine',
        crustaceans: 'Crostacei e prodotti derivati',
        eggs: 'Uova e prodotti derivati',
        fish: 'Pesce e prodotti derivati',
        peanuts: 'Arachidi e prodotti derivati',
        soya: 'Soia e prodotti derivati',
        milk: 'Latte e prodotti derivati',
        nuts: 'Frutta a guscio',
        celery: 'Sedano e prodotti derivati',
        mustard: 'Senape e prodotti derivati',
        sesame: 'Semi di sesamo e prodotti derivati',
        lupins: 'Lupini e prodotti derivati',
        molluscs: 'Molluschi e prodotti derivati',
        corn: 'Mais e prodotti derivati',
        wheat: 'Grano e prodotti derivati',
        rye: 'Contiene grano e prodotti derivati',
        barley: 'Orzo e prodotti derivati',
        oats: 'Avena e prodotti derivati',
        spelt: 'Spelta e prodotti derivati',
        khorasan: 'Khorasan e prodotti derivati',
        walnuts: 'Noci e prodotti derivati',
        pecanNuts: 'Noci pecan e prodotti derivati',
        brazilNuts: 'Noci del Brasile e prodotti derivati',
        pistachioNuts: 'Pistacchi e prodotti derivati',
        macadamiaNuts: 'Noci macadamia e prodotti derivati',
        almonds: 'Mandorle e prodotti derivati',
        hazelnuts: 'Contiene nocciole e prodotti derivati',
        cashews: 'Anacardi e prodotti derivati',
        seeds: 'Semi e prodotti derivati',
        poppySeeds: 'Semi di papavero e prodotti derivati',
        sunflowerSeeds: 'Semi di girasole e prodotti derivati',
        poultryMeat: 'Carne di pollame e prodotti derivati',
        beef: 'Carne bovina e prodotti derivati',
        pigmeat: 'Carne suina e prodotti derivati',
        yeast: 'Estratto di lievito',
        sulfurDioxideAndSulphites: 'Contiene anidride solforosa e solfiti e prodotti derivati',
        rye2: 'Contiene segale e prodotti derivati dalla segale',
        gluten: 'Glutine',
      },
      additives: {
        additives: 'Additivi',
        1: 'con colorante',
        2: 'con conservante',
        3: 'con antiossidante',
        4: 'con esaltatore di sapidità',
        5: 'contiene solfiti',
        6: 'annerito',
        7: 'con fosfato',
        8: 'con proteine del latte (per prodotti a base di carne)',
        9: 'caffeinato',
        10: 'chinino',
        11: 'con dolcificante',
        12: 'cerato',
        13: 'nuovo',
        14: 'contiene alcol',
        15: 'contiene segale e prodotti derivati',
        16: 'con sale di stagionatura ai nitriti',
        17: 'regolatore di acidità',
        18: 'stabilizzante',
        19: 'acidificante',
      },
      traces: {
        traces: 'Tracce',
        sesame: 'può contenere tracce di sesamo e prodotti derivati',
        soy: 'può contenere tracce di soia e prodotti derivati',
        peanuts: 'può contenere tracce di arachidi e prodotti derivati',
        wheat: 'può contenere tracce di grano e prodotti derivati',
        lupins: 'può contenere tracce di lupini e prodotti derivati',
        treeNuts: 'può contenere tracce di frutta a guscio e prodotti derivati',
        sulfurDioxide: 'può contenere tracce di anidride solforosa e solfiti e prodotti derivati',
        fish: 'può contenere tracce di pesce e prodotti derivati',
        milk: 'può contenere tracce di latte e prodotti derivati',
        eggs: 'può contenere tracce di uova e prodotti derivati',
        mustard: 'può contenere tracce di senape e prodotti derivati',
        barley: 'può contenere tracce di orzo e prodotti derivati',
      },
      nutrition: {
        portionInG: 'Dimensione porzione (g)',
        portionInML: 'Dimensione porzione (ml)',
        energyKcalPerPortion: 'Energia (kcal)',
        energyKcalPer100G: 'Energia (kcal/100g)',
        energyKcalPer100ML: 'Energia (kcal/100ml)',
        energyKjPerPortion: 'Energia (kj)',
        energyKjPer100G: 'Energia (kj/100g)',
        energyKjPer100ML: 'Energia (kj/100ml)',
        fatPerPortion: 'Grassi (g)',
        fatPer100G: 'Grassi (g/100g)',
        fatPer100ML: 'Grassi (g/100ml)',
        saturatesPerPortion: 'Acidi grassi saturi (g)',
        saturatesPer100G: 'Acidi grassi saturi (g/100g)',
        saturatesPer100ML: 'Acidi grassi saturi (g/100ml)',
        carbohydratePerPortion: 'Carboidrati (g)',
        carbohydratePer100G: 'Carboidrati (g/100g)',
        carbohydratePer100ML: 'Carboidrati (g/100ml)',
        sugarPerPortion: 'Zuccheri (g)',
        sugarPer100G: 'Zuccheri (g/100g)',
        sugarPer100ML: 'Zuccheri (g/100ml)',
        proteinPerPortion: 'Proteine (g)',
        proteinPer100G: 'Proteine (g/100g)',
        proteinPer100ML: 'Proteine (g/100ml)',
        saltPerPortion: 'Sale (g)',
        saltPer100G: 'Sale (g/100g)',
        saltPer100ML: 'Sale (g/100ml)',
        highFat: 'Alto Contenuto di Grassi',
        highSugar: 'Alto Contenuto di Zuccheri',
      },
      features: {
        basic: 'Base',
        features: 'Caratteristiche',
        vegan: 'Vegano',
        vegetarian: 'Vegetariano',
        glutenFree: 'Senza glutine',
        noCarb: 'Senza carboidrati',
        alkaline: 'Alcalino',
        lactoseFree: 'Senza lattosio',
        new: 'Nuovo',
        special: 'Speciale',
        topSelling: 'Più venduto',
        warm: 'Caldo',
        cold: 'Freddo',
        fish: 'Pesce',
        chicken: 'Pollo',
        beef: 'Manzo',
        pork: 'Maiale',
        prepackaged: 'Preconfezionato',
        protein: 'Ricco di proteine',
        healthy: 'Salutare',
        menu: 'Menu',
        sticker: 'Adesivo',
        spicyLevel: {
          label: 'Livello di piccantezza',
          light: 'Piccante',
          medium: 'Molto piccante',
          extra: 'Extra piccante',
        },
      },
    },
  },
  articleManager: {
    index: 'Visibilità Articoli e Opzioni',
    overview: 'Panoramica',
    mainArticle: 'Articoli Principali',
    optionArticle: 'Articoli Opzione',
    options: 'Opzioni',
    deactivateAll: 'Disattiva Tutti',
    activateAll: 'Attiva Tutti',
    onlyOne: 'No, solo questo',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    filter: {
      category: 'Scegli Categoria',
      status: 'Scegli Stato Articolo',
      type: 'Articolo o Articolo Opzione',
      search: 'Cerca',
      allStatus: 'Tutti',
      active: 'Visibile',
      notActive: 'Invisibile',
      article: 'Articolo',
      options: 'Opzioni',
    },
    table: {
      visibility: 'Visibilità',
      name: 'Nome',
      category: 'Categoria',
      options: 'Opzioni',
      price: 'Prezzo',
      optionGroup: 'Gruppo Opzioni',
      connectedArticles: 'Articoli collegati',
      description: 'Descrizione',
      loadMore: 'Carica altro',
    },
    notification: {
      saved: 'Modifiche salvate.',
      sameArticleNumber:
        "Abbiamo trovato articoli con lo stesso numero articolo. Vuoi attivare/disattivare (a seconda dell'azione) tutti, o solo questo?",
    },
  },
  translation: {
    start: 'Traduzione avviata. Questo può richiedere fino a 10 minuti',
    index: 'Traduzione',
    overview: 'Panoramica',
    translate: 'traduci',
    languages: {
      en: 'Inglese',
      de: 'Tedesco',
      fr: 'Francese',
      nl: 'Olandese',
      it: 'Italiano',
      pl: 'Polacco',
      es: 'Spagnolo',
      zh: 'Cinese',
      ru: 'Russo',
      tr: 'Turco',
      da: 'Danese',
      ja: 'Giapponese',
      is: 'Islandese',
      pt: 'Portoghese',
      cz: 'Ceco',
      ar: 'Arabo',
      el: 'Greco',
      ko: 'Coreano',
      th: 'Tailandese',
      vi: 'Vietnamita',
      hi: 'Hindi',
      ur: 'Urdu',
      tl: 'Tagalog',
      id: 'Indonesiano',
      no: 'Norvegese',
      sv: 'Svedese',
      lt: 'Lituano',
      fi: 'Finlandese',
    },
  },
  payment: {
    index: 'Pagamenti',
    overview: 'Panoramica',
    refundArticle: 'Rimborsa Articolo',
    refundArticleSmoothr: 'Rimborsa Articolo Solo Smoothr',
    refundOrder: 'Rimborsa Ordine',
    refundOrderSmoothr: 'Rimborsa Ordine Solo Smoothr',
    refundQuestion: 'Sei sicuro di voler rimborsare? Questa azione non può essere annullata.',
    refunded: 'Fa parte di un rimborso',
    order: 'Ordine',
    refund: 'Rimborsi disponibili',
    searchCode: 'Cerca per codice ordine...',
    searchTransactionId: 'Cerca per ID transazione...',
    sendInvoice: 'Invia fattura',
    showLogs: 'Mostra Log',
    hideLogs: 'Nascondi Log',
    logs: {
      logs: 'Log',
      noLogs: 'Nessun log disponibile per questo pagamento.',
      payment: 'Pagamento',
      provider: 'Provider di Pagamento',
      venue: 'Punto Vendita',
      messageType: 'Tipo Messaggio',
      httpMethod: 'Metodo HTTP',
      httpStatusCode: 'Codice Stato HTTP',
      url: 'URL',
      endpoint: 'Endpoint',
      result: 'Risultato',
      createdAt: 'Creato il',
      updatedAt: 'Aggiornato il',
      expiresAt: 'Scade il',
    },
    notification: {
      invoiceSent: 'La fattura è stata inviata con successo.',
    },
    table: {
      sum: 'Somma',
      tip: 'Mancia',
      status: 'Stato',
      hasRefunds: 'Rimborsi',
      codes: 'Codici',
      method: 'Metodo di Pagamento',
      createdAt: 'Data',
      id: 'Id',
      merchantReference: 'Riferimento Commerciante',
      checkoutId: 'Riferimento PSP',
      subMethod: 'Sotto Metodo',
      orderedArticles: 'Articoli Ordinati',
      checkoutOrderedArticles: 'Articoli Ordinati Checkout',
    },
    form: {
      quantity: 'Quantità',
      email: 'E-Mail',
    },
  },
  option: {
    index: 'Gestisci Opzioni',
    create: 'Crea una nuova Opzione',
    edit: 'Modifica Opzione',
    add: 'Aggiungi Opzione',
    copy: 'Copia Opzione',
    unlinkedOptions: 'Opzioni non associate ad articoli',
    empty:
      'Sembra che tu non abbia ancora aggiunto nessuna opzione. Crea il tuo primo gruppo di opzioni per rendere gli articoli ancora migliori e personalizzabili.',
    overview: 'Panoramica',
    tabs: {
      general: 'Generale',
      articles: 'Articoli',
      features: 'Caratteristiche',
      availableHours: 'Orari Disponibili',
      compound: {
        features: 'Caratteristiche',
        new: 'Nuovo',
        special: 'Speciale',
        topSelling: 'Più venduto',
      },
    },
    articles: {
      table: {
        name: 'Nome',
        description: 'Descrizione',
        price: 'Prezzo',
        sortOrder: 'Ordine',
        internalNote: 'Nota Interna',
        internalName: 'Nome Interno',
        assets: 'Immagini',
        active: 'Attivo',
        visible: 'Visibile',
        number: 'Numero',
      },
      addTitle: 'Aggiungi articolo',
      editTitle: 'Modifica articolo',
    },
    table: {
      name: 'Nome',
      description: 'Descrizione',
      requiredAmount: 'Quantità Richiesta',
      limit: 'Limite',
      hasMultiple: 'Ha Multiplo',
      sortOrder: 'Ordine',
      visible: 'Visibile',
      article: 'Articolo',
    },
    form: {
      name: 'Nome',
      description: 'Descrizione',
      shortDescription: 'Breve Descrizione',
      image: 'Immagine',
      externalId: 'ID Esterno',
      limit: 'Limite',
      active: 'Attivo',
      visible: 'Visibile',
      virtual: 'Virtuale',
      sort: 'Ordine',
      printerSort: 'Ordine Stampante',
      requiredAmount: 'Quantità Richiesta',
      hasMultiple: 'Multiplo',
      displayIdentifiers: 'Identificatori Visivi',
      displayMode: 'Modalità Visualizzazione',
      displayModeSot: 'Modalità Visualizzazione SOT',
      displayModeMobile: 'Modalità Visualizzazione Mobile',
      tags: 'Etichette',
      printGroups: 'Gruppi di Stampanti',
    },
    deleteHeader: 'Elimina Opzioni',
    deleteInfo: 'Sei sicuro di voler eliminare queste opzioni? Questa azione non può essere annullata.',
    deleteSelected: 'Elimina Selezionati',
  },
  category: {
    index: 'Gestisci Categorie',
    create: 'Crea una nuova Categoria',
    edit: 'Modifica Categoria',
    add: 'Aggiungi Categoria',
    overview: 'Panoramica',
    availableHours: 'Orari Disponibili',
    table: {
      name: 'Nome',
      sort: 'Ordine',
      mainCategory: 'Categoria Principale',
      visible: 'Visibile',
    },
    form: {
      name: 'Nome',
      description: 'Descrizione',
      mainCategory: 'Categoria Principale',
      sort: 'Ordine',
      displayMode: 'Modalità Visualizzazione',
      mainRecommendations: 'Raccomandazioni Principali',
      displayIdentifiers: 'Identificatori Visivi',
      visible: 'Visibile',
      image: 'Immagine',
      icon: 'Icona',
    },
    tabs: {
      features: 'Caratteristiche',
      new: 'Nuovo',
      special: 'Speciale',
      topSelling: 'Più venduto',
    },
  },
  subscriptionCategories: {
    index: 'Gestisci Categoria Abbonamento',
    create: 'Crea una nuova Categoria Abbonamento',
    edit: 'Modifica Categoria Abbonamento',
    add: 'Aggiungi Categoria Abbonamento',
    overview: 'Panoramica',
    table: {
      name: 'Nome',
    },
    form: {
      name: 'Nome',
      description: 'Descrizione',
      image: 'Immagine',
      subscriptions: 'Abbonamenti',
      venues: 'Punti Vendita',
      canCombine: 'Combina',
      isActive: 'Attivo',
    },
  },
  subscription: {
    index: 'Gestisci Abbonamento',
    create: 'Crea un nuovo Abbonamento',
    edit: 'Modifica Abbonamento',
    add: 'Aggiungi Abbonamento',
    overview: 'Panoramica',
    table: {
      name: 'Nome',
    },
    form: {
      name: 'Nome',
      description: 'Descrizione',
      image: 'Immagine',
      useMasterFoodcard: 'Usa Foodcard Principale',
      maxPricePerOrder: 'Prezzo Massimo per Ordine',
      maxPricePerArticle: 'Prezzo Massimo per Articolo',
      maxArticlesPerOrder: 'Numero Massimo Articoli per Ordine',
      maxOrdersPerDay: 'Numero Massimo Ordini al Giorno',
      minimumOrderOffset: 'Offset Ordine Minimo',
      isActive: 'Attivo',
      automaticallyRenew: 'Rinnovo Automatico',
      tax: 'IVA',
      articles: 'Articoli',
      venues: 'Punti Vendita',
      linkedCustomerGroup: 'Gruppo Clienti Collegato',
      price: 'Prezzo',
      factor: 'Fattore',
      unit: 'Unità',
      default: 'Predefinito',
    },
  },
  membership: {
    index: 'Gestisci Membership',
    create: 'Crea una nuova Membership',
    edit: 'Modifica Membership',
    add: 'Aggiungi Membership',
    overview: 'Panoramica',
    table: {
      name: 'Nome',
    },
    form: {
      name: 'Nome',
      description: 'Descrizione',
      image: 'Immagine',
      multiplier: 'Moltiplicatore',
      neededPoints: 'Punti Necessari',
      piggyId: 'ID Piggy',
      customerGroup: 'Gruppo Clienti',
    },
    tier: {
      membershiptier1: 'livellomembership1',
      membershiptier2: 'livellomembership2',
      membershiptier3: 'livellomembership3',
      membershiptier4: 'livellomembership4',
      membershiptier5: 'livellomembership5',
    },
  },
  table: {
    index: 'Gestisci Tavoli',
    create: 'Crea un nuovo Tavolo',
    exportQrs: 'Esporta Codici QR',
    assignLightspeedWaiter: 'Assegna cameriere Lightspeed',
    toggleTablesByRange: 'Attiva/Disattiva Tavoli per Intervallo',
    toggleTablesByTag: 'Attiva/Disattiva Tavoli per Etichetta',
    edit: 'Modifica Tavolo',
    add: 'Aggiungi Tavolo',
    overview: 'Panoramica',
    table: {
      number: 'Numero',
      description: 'Descrizione',
      active: 'Attivo',
      tags: 'Etichette',
      qr: 'Codice QR',
      sanifairDeviceId: 'ID Dispositivo Sanifair',
    },
    form: {
      number: 'Numero',
      description: 'Descrizione',
      sanifairDeviceId: 'ID Dispositivo Sanifair',
      lightspeedWaiterId: 'Cameriere Lightspeed',
      simphonyRvcRef: 'Riferimento RVC Simphony',
      pendingCashPaymentEnabled: 'Attiva pagamenti in contanti aperti',
      openOrdersEnabled: 'Attiva ordini aperti',
      viewStaff: 'Visualizza Personale',
      select: 'Seleziona',
      isActive: 'Attivo',
      start: 'Inizio',
      end: 'Fine',
      tag: 'Etichetta',
    },
    notification: {
      assignLightspeedWaiterSuccess: 'Cameriere Lightspeed assegnato con successo ai tavoli selezionati.',
      assignLightspeedWaiterError:
        "Si è verificato un errore durante l'assegnazione del cameriere Lightspeed ai tavoli selezionati.",
      massActiveSuccess: 'Tavoli aggiornati con successo.',
      massActiveError: "Si è verificato un errore durante l'aggiornamento dei tavoli.",
    },
  },
  venue: {
    index: 'Gestisci Punti Vendita',
    create: 'Crea un nuovo Punto Vendita',
    copyFoodcard: 'Copia foodcard',
    editMasterId: 'Modifica Master-ID',
    copyArticles: 'Copia articoli',
    importHellotess: 'Importa foodcard da Hellotess',
    importGastrofix: 'Importa foodcard da Gastrofix',
    importDeliverect: 'Importa foodcard da Deliverect',
    importSimphony: 'Importa foodcard da Simphony',
    generalImport: 'Importazione Foodcard Generale',
    panic: 'Panico',
    ppConnected: 'Stato Account PayPal',
    ppConnectedSuccess: 'Account PayPal collegato con successo.',
    ppConnectedError: 'Account PayPal non collegato o operazione fallita.',
    lightspeedAuthorize: 'Autorizza Lightspeed',
    lightspeedAuthorized: 'Lightspeed autorizzato con successo',
    lightspeedNotAuthorized: 'Lightspeed non autorizzato',
    generateSlugAuto: 'Genera slug automaticamente',
    standardSlots: 'Slot Standard',
    terminalSlots: 'Slot Terminale',
    preorderSlots: 'Slot Preordine',
    createSimple: 'Crea un nuovo Punto Vendita',
    overview: 'Panoramica',
    add: 'Aggiungi Punto Vendita',
    sync: 'Sincronizza Punto Vendita',
    tooltipCannotSync: 'La sincronizzazione è già in corso. Attendere o contattare un amministratore',
    liftSyncLock: 'Rimuovi blocco sincronizzazione',
    refresh: 'Aggiorna',
    copy: 'Copia punto vendita',
    copyVenueOnly: 'Copia solo punto vendita',
    deleteFoodcard: 'Elimina Foodcard',
    copyConfirm: 'Sei sicuro di voler creare un duplicato del punto vendita?',
    copySuccess: 'Punto vendita copiato',
    archive: 'Archivia',
    testOrder: 'Invia Ordine di Test',
    registerPayPal: 'Collega Account PayPal',
    checkPayPalOnboarding: 'Verifica Stato Account PayPal',
    deliveryFees: 'Tariffe di Consegna',
    deliveryFeesRadius: 'Tariffe di Consegna per Raggio',
    deliveryFeesPostalCode: 'Tariffe di Consegna per Codice Postale',
    deliveryFeesAreas: 'Tariffe di Consegna per Area',
    edit: 'Modifica Punto Vendita',
    parkCollect: 'Park & Collect',
    migrate: 'Migra Punto Vendita',
    stations: 'Stazioni',
    migration: 'Migrazione',
    eodReport: 'Report fine giornata',
    customerSupportMail: 'Supporto clienti',
    generateWebAppSlug: 'Genera Slug App Web',
    panicInfo: 'Informazioni: Panico per il Punto Vendita {venue} è attivato fino alle {panicEndAt}. {reason}.',
    snoozing: 'Opzioni Snooze',
    offsetReset: 'Ora Reset Offset',
    milesAndMore: 'Miles & More',
    kost: 'KOST',
    ncr: 'NCR',
    revel: 'Revel',
    arcavis: 'Arcavis',
    erpVoucher: 'Buono ERP',
    tips: 'Mance',
    notification: {
      testOrderSuccess: "L'ordine di test è riuscito.",
      testOrderError:
        "L'ordine di test non è riuscito. Controlla le tue impostazioni o se hai ancora problemi contatta un amministratore.",
      sendInvoiceSuccess: 'Fattura inviata con successo.',
      createCreditNoteSuccess: 'Nota di credito creata con successo.',
      registerPayPalError: 'Impossibile autorizzare paypal.',
      checkPayPalOnboardingError: 'Impossibile verificare lo stato di onboarding paypal.',
      checkPayPalOnboardingSuccess: 'Aggiorna la pagina per vedere le modifiche.',
      sendInvoiceError: 'Invio fattura fallito.',
      createCreditNoteError: 'Creazione nota di credito fallita.',
      copyOptionSuccess: 'Opzione copiata',
      copyOptionError: 'Copia opzione fallita. Controlla i log.',
      authorizePayPal: 'Per autorizzare, compila i campi ID Commerciante ed Email nelle Credenziali PayPal e salva.',
      copyRunning: 'Copia del punto vendita avviata e in corso.',
      copyError: 'Copia punto vendita fallita. Controlla i log.',
      webAppSlug:
        'Sei sicuro di voler generare il campo Slug App Web? In questo caso verrà fatto per tutti i punti vendita.',
      masterId: 'Master-ID',
      deleteSuccess: 'Foodcard eliminata con successo!',
      refreshSuccess: 'Aggiornamento del punto vendita completato con successo.',
      refreshError: "Si è verificato un errore durante l'aggiornamento del punto vendita.",
      sepa: {
        createSuccess: 'Nuovo link di registrazione mandato SEPA creato con successo',
        createError: 'Impossibile creare un nuovo link di registrazione mandato SEPA',
        paySuccess: 'Nuovo pagamento SEPA creato con successo',
        payError: 'Impossibile creare un nuovo pagamento SEPA',
      },
    },
    filter: {
      publishedStatus: 'Stato Pubblicazione',
      published: 'Pubblicato',
      unpublished: 'Non Pubblicato',
      verifiedStatus: 'Stato Verifica',
      syncStatus: 'Stato Sincronizzazione',
      idle: 'Non in Sincronizzazione',
      sync: 'In Sincronizzazione',
      verified: 'Verificato',
      customerGroup: 'Gruppo Clienti',
      unverified: 'Non Verificato',
      deletedAt: 'Visualizza Archiviati',
      isServiceActivatedStatus: 'Stato Servizio Attivato',
      deliveryEnabledStatus: 'Stato Consegna Abilitata',
      panicModeStatus: 'Stato Panico',
      activated: 'Attivato',
      notActivated: 'Non Attivato',
      enabled: 'Abilitato',
      notEnabled: 'Non Abilitato',
      panicActive: 'In corso',
      panicInactive: 'Inattivo',
    },
    station: {
      placeholder: 'Digita nome stazione',
      deleteStation: 'Sei sicuro di voler eliminare la stazione?',
      addStation: '+ Aggiungi stazione',
    },
    confirmation: {
      verify: {
        title: 'Conferma Punto Vendita',
        text: 'Facendo clic sul pulsante qui sotto, accetti che tutti gli articoli, i prezzi e le impostazioni del punto vendita siano corretti. Inoltre hai caricato termini di servizio, privacy e disclaimer. Per eventuali impostazioni errate, sei responsabile.',
        action: 'Verifica Punto Vendita',
      },
      publish: {
        title: 'Conferma Pubblicazione',
        text: 'Facendo clic sul pulsante qui sotto, accetti che tutti gli articoli, i prezzi e le impostazioni del punto vendita siano corretti. Per eventuali impostazioni errate, sei responsabile.',
        action: 'Pubblica Punto Vendita',
      },
      deleteFoodcard: {
        title: "Sei sicuro di voler eliminare l'intera foodcard?",
        text: 'Stai eliminando tutte le categorie, gli articoli, i gruppi di opzioni, gli articoli opzione e le etichette con questa azione.<br/><br/>Questa azione non può essere annullata.',
      },
    },
    verify: 'Verifica',
    publish: 'Pubblica',
    credentials: 'Credenziali',
    payment: 'Pagamento',
    order: 'Ordine',
    preorder: 'Preordine',
    slotting: 'Impostazioni Slot',
    documents: 'Documenti',
    invoices: {
      createCreditNote: 'Crea Nota di Credito',
      createCreditNoteNet: 'Crea Nota di Credito (Valore Netto)',
      send: 'Invia Fattura',
      transactions: 'Transazioni',
      balance: 'Saldo',
      type: 'Tipo Fattura',
      refOrNote: 'Rif Fattura / Nota',
      createdAt: 'Creato il',
      amount: 'Importo',
      setupFee99: 'Costo di Configurazione (99€)',
      setupFee49: 'Costo di Configurazione (49€)',
      premiumPrinterPackage: 'Pacchetto Stampante Premium',
      printerTablet: 'Tablet con stampante integrata (319,00 + 8,00 €)',
      printerTablet200: 'Tablet con stampante integrata (200€ + 8€)',
      printerTablet230: 'Tablet con stampante integrata (230€ + 8€)',
      provision: 'Provvigione',
      creditNoteNet: 'Nota di Credito (Valore Netto)',
      status: 'Stato',
    },
    productCombos: {
      addCombo: 'Aggiungi Combo',
      addArticle: 'Aggiungi Articolo',
      addColumn: 'Aggiungi Colonna',
      deleteColumn: 'Elimina Colonna',
      result: 'Seleziona articolo risultato',
      column: 'Seleziona articolo',
    },
    ci: 'Integrazione Checkout',
    cip: 'Proprietà Integrazione Checkout',
    general: 'Generale',
    details: 'Dettagli',
    contact: 'Contatto',
    whiteLabel: 'whiteLabel',
    invoiceReceiver: 'Indirizzo di Fatturazione',
    address: 'Indirizzo',
    settings: 'Impostazioni',
    sizeSettings: 'Impostazioni Dimensioni',
    orderOffsets: 'Offset Ordine',
    preorderOffsets: 'Offset Preordine',
    fireTimeOffsets: 'Offset Ora Preparazione',
    uberDelivery: 'Uber Delivery',
    miscellaneous: 'Varie',
    preorderPayment: 'Pagamento Preordine',
    deliveryPayment: 'Pagamento Consegna Preordine',
    sepaCredentials: 'Credenziali SEPA',
    ccCredentials: 'Credenziali Carta di Credito',
    ppCredentials: 'Credenziali PayPal',
    sbCredentials: 'Credenziali SofortBanking',
    apCredentials: 'Credenziali ApplePay',
    gpCredentials: 'Credenziali GooglePay',
    walleeCredentials: 'Credenziali Wallee',
    worldlineCredentials: 'Credenziali Worldline',
    datatransCredentials: 'Credenziali DataTrans',
    adyenCredentials: 'Credenziali Adyen',
    walleePaymentConfs: 'Pagamento Wallee',
    neptingCredentials: 'Credenziali Nepting',
    eServiceCredentials: 'Credenziali eService',
    openingHours: 'Orari di Apertura',
    specialOpeningHours: 'Orari di Apertura Speciali',
    deliveryHours: 'Orari di Consegna',
    specialDeliveryHours: 'Orari di Consegna Speciali',
    salesforce: 'Salesforce',
    salesforcePromotions: 'Promozioni Salesforce',
    sanifair: 'Sanifair',
    delfi: 'Delfi',
    loyalty: 'Fedeltà',
    boardingPass: 'Boarding Pass',
    datev: 'Datev',
    storeLink: 'Link negozio',
    viewCounters: 'Contatori Visite',
    voucherify: 'Voucherify',
    grubtech: 'GrubTech',
    finances: 'Finanze',
    nutrition: 'Valori nutrizionali',
    panicModeHistory: {
      startAt: 'Inizio',
      endAt: 'Fine',
      reason: 'Motivo',
    },
    locTypes: {
      bar: 'Bar',
      club: 'Club',
      restaurant: 'Ristorante',
      db: 'Deutsche Bahn',
      cinema: 'Cinema',
      other: 'Altro',
    },
    tabs: {
      general: 'Generale',
      payment: 'Pagamento',
      terminal: 'Terminale',
      preorder: 'Preordine',
      ci: 'Integrazione Checkout',
      orderOffsets: 'Offset Ordine',
      order: 'Ordine',
      slotting: 'Slotting',
      cateringHours: 'Orari Catering',
      documents: 'Documenti',
      openingHours: 'Orari di Apertura',
      productCombos: 'Combinazioni Prodotto',
      deliveryHours: 'Orari di Consegna',
      deliveryProviders: 'Fornitori di Consegna',
      externalDeliveryService: 'Servizio di Consegna Esterno',
      orderProviders: 'Fornitori di Ordini',
      invoices: 'Fatture',
      sanifair: 'Sanifair',
      salesforce: 'Salesforce',
      delfi: 'Delfi',
      loyalty: 'Fedeltà',
      boardingPass: 'Boarding Pass',
      datev: 'Datev',
      milesAndMore: 'Miles & More',
      erpVoucher: 'Buono ERP',
      tips: 'Mance',
      voucherify: 'Voucherify',
      grubtech: 'GrubTech',
      finances: 'Finanze',
      nutrition: 'Valori nutrizionali',
    },
    table: {
      name: 'Nome',
      shortId: 'ID Breve',
      sort: 'Ordine',
      email: 'E-Mail',
      street: 'Via',
      number: 'Numero',
      city: 'Città',
      legalForm: 'Forma Legale',
      locType: 'Tipo',
      vatNumber: 'Partita IVA',
      vatNumberGermany: 'Numero Fiscale Tedesco',
      isServiceActivated: 'Servizio Attivato',
      deliveryEnabled: 'Consegna Abilitata',
      customerGroup: 'Gruppo Clienti',
      checkoutIntegration: 'Integrazione Checkout',
      piggyLoyaltyEnabled: 'Fedeltà',
      isPublished: 'Pubblicato',
      webAppSlug: 'Slug App Web',
      masterId: 'Master-ID',
      externalOrderProviderStatus: 'Stato Negozio (Wolt/Uber Eats)',
      preorderTakeAway: 'Preordine Take Away',
      panicModeHistory: 'Cronologia Panico',
      cases: 'Casi',
    },
    form: {
      secondaryCodeEnabled: 'Codice Secondario Abilitato',
      standardOrderOffsets: 'Offset Ordine Standard',
      terminalInsideOffsets: 'Offset Interno Terminale',
      terminalTakeAwayOffsets: 'Offset Take Away Terminale',
      preorderInsideOffsets: 'Offset Interno Preordine',
      preorderTakeAwayOffsets: 'Offset Take Away Preordine',
      preorderDeliveryOffsets: 'Offset Consegna Preordine',
      cateringTakeAway: 'Consenti Catering Take Away',
      cateringDelivery: 'Consenti Catering Consegna',
      cateringTakeAwayHours: 'Orari Catering Take Away',
      cateringDeliveryHours: 'Orari Catering Consegna',
      cateringDeliveryOffsets: 'Offset Consegna Catering',
      cateringTakeAwayOffsets: 'Offset Take Away Catering',
      couponsEnabled: 'Couponing',
      cateringSlots: 'Slot Catering',
      parkCollectionLocationText: 'Testo Posizione',
      venue: 'Punto Vendita',
      masterId: 'Master-ID',
      sort: 'Ordine',
      sourceVenue: 'Punto Vendita Sorgente',
      targetVenue: 'Punto Vendita Destinazione',
      sendEodReport: 'Invia report fine giornata alle email',
      sendEodReportEmails: 'Elenco email per inviare report',
      source: 'Sorgente',
      image: 'Immagine',
      masterType: 'Tipo Ordine',
      uberCustomerId: 'ID Cliente Uber',
      uberDeliveryEnabled: 'Uber Consegna Abilitata',
      uberBatchSize: 'Dimensione Batch',
      externalDeliveryService: {
        name: 'Nome',
        link: 'Link',
        icon: 'Icona',
      },
      name: 'Nome',
      newName: 'Nuovo Nome',
      asSlave: 'Crea il punto vendita come slave del punto vendita selezionato',
      sapNumber: 'Numero SAP',
      externalLocationId: 'ID Posizione Esterno',
      loginRequired: 'Richiesta Login',
      restaurantToken: 'Token Ristorante Smoothr',
      standardSlot: 'Max. Ordini Standard per intervallo',
      takeAwaySlot: 'Max. Ordini TakeAway per intervallo',
      calculateDays: 'Numero di giorni per calcolare gli slot',
      insideSlot: 'Max. Ordini Interno per intervallo',
      deliverySlot: 'Max. Ordini Consegna per intervallo',
      properties: 'Proprietà',
      syncType: 'Tipo Sincronizzazione',
      fullName: 'Nome Azienda',
      currency: 'Valuta',
      deliveryPostalCodes: 'Codici Postali Consegna',
      deliveryPostalCodesHint: 'Inserisci un codice postale con una città correlata (es. 50679 Colonia)',
      country: 'Paese',
      locType: 'Tipo Posizione',
      deliveryFee: 'Tariffa consegna in {currency} (se non ulteriormente specificato)',
      deliveryByRadius: 'Usa Raggio Consegna (Altrimenti per Codici Postali)',
      deliveryByAreas: 'Usa Aree Consegna (Altrimenti per Codici Postali)',
      provisionRate: 'Tasso Provvigione',
      bcsig: 'BCSIG',
      supplier: 'Fornitore',
      webAppUrl: 'URL App Web',
      panicEndAt: 'Panico (se attivo, i preordini non sono possibili)',
      provisionFixedRate: 'Tasso Provvigione Fisso',
      readableId: 'ID Breve',
      migrationType: 'Tipo Migrazione',
      deliveryRadius: 'Raggio Consegna',
      deliveryRadiusMax: 'Raggio Consegna (max)',
      isPublished: 'Pubblicato',
      venues: 'Punti Vendita',
      deliveryHours: 'Orari di Consegna',
      sanifair: 'Impostazioni Sanifair',
      active: 'Attivo',
      virtualOrders: 'Consenti Ordini Virtuali',
      stock: 'Magazzino',
      movDelivery: 'Valore Minimo Ordine -- Consegna (EUR)',
      checkoutIntegration: 'Integrazione Checkout',
      printerIntegration: 'Integrazione Stampante',
      readyOffset: 'Offset Preparazione',
      readyOffsetDelivery: 'Offset Preparazione Consegna',
      interval: 'Dimensione Intervallo',
      reserved: 'Ordini Riservati',
      max: 'Max Ordini per Intervallo (deprecato)',
      notPickedOffset: 'Offset non ritirato',
      isServiceActivated: "Stato servizio (se non attivato, l'ordinazione è disabilitata)",
      isCallingSystemEnabled: 'Sistema di chiamata',
      inventoryEnabled: 'Inventario Abilitato',
      milesAndMoreEnabled: 'Miles & More Abilitato',
      erpVoucherEnabled: 'Buono ERP Abilitato',
      legalForm: 'Forma Legale',
      email: 'E-Mail',
      orderEmail: 'E-Mail Ordine',
      storeEmail: 'E-Mail Negozio',
      web: 'Sito Web',
      standardOrders: 'Consenti Ordini Standard',
      preorderTakeAway: 'Consenti Preordine Take Away',
      preorderParkCollect: 'Consenti Park & Collect',
      preorderFoodspot: 'Consenti Foodspot',
      preorderIn: 'Consenti Preordine In House',
      preorderDelivery: 'Consenti Consegna',
      autoAccept: 'Accettazione automatica in',
      autoAcceptTerminal: 'Accettazione automatica ordine terminale in',
      checkoutIn: 'Checkout in',
      printIn: 'Stampa in',
      autoReset: 'Reset Automatico in',
      orderTimeout: 'Timeout Ordine',
      orderTimeoutEnabled: 'Attiva Timeout Ordine',
      phone: 'Telefono',
      fax: 'Fax',
      city: 'Città',
      area: 'Città più Vicina',
      street: 'Via',
      streetAddress: 'Indirizzo',
      number: 'Numero',
      company: 'Azienda',
      postalCode: 'Codice Postale',
      federalState: 'Stato Federale',
      deliveryAddress: 'Indirizzo di Consegna',
      orderPrinterTabletPackageInfo:
        'Ordina un tablet con stampante integrata per {price}€. Senza una stampante riceverai nuovi ordini solo via email.',
      orderPremiumPackage: 'Ordina Stampante',
      timezone: 'Fuso Orario',
      googlePlacesId: 'ID Google Places',
      customerGroup: 'Gruppo Clienti',
      sendProvisionReportPeriod: 'Invia Report Provvigione',
      lastInvoiceNumber: 'Ultimo numero fattura',
      sendProvisionReportPeriodNonInvoiceable: 'Invia Report Provvigione (senza numero fattura)',
      vatNumber: 'Partita IVA',
      vatNumberQuestion: 'Usare Partita IVA?',
      vatNumberGermany: 'Numero Fiscale Tedesco (es. 12/345/67890)',
      vatNumberGermanyQuestion: 'Nessuna Partita IVA?',
      mov: 'MOV',
      from: 'Da',
      fee: 'Tariffa',
      deliveryArea: 'Area di Consegna',
      secureCode: 'Codice Sicurezza',
      selfCertification: 'Autocertificazione',
      reviewHyperlink: 'Collegamento recensione',
      pdfUpload: 'Carica file PDF',
      kmlUpload: 'Carica file KML',
      insertLink: 'Inserisci Link',
      nutritionTable: 'Tabella Nutrizionale',
      nutritionInfo: 'Info Nutrizionali',
      gpsManualInput: 'Inserimento Manuale (Coordinate GPS)',
      gpsCorrect: 'Coordinate GPS corrette?',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      adyenEnabled: 'Adyen Abilitato',
      adyenPaypalEnabled: 'Adyen PayPal Abilitato',
      merchantAccount: 'Account Commerciante',
      urlPrefix: 'Prefisso URL',
      clientKey: 'Chiave Client',
      property: 'Proprietà',
      paymentEnabled: 'Pagamento Abilitato',
      sepaEnabled: 'SEPA Abilitato',
      sbEnabled: 'SofortBanking Abilitato',
      gpEnabled: 'GooglePay Abilitato',
      apEnabled: 'ApplePay Abilitato',
      ppEnabled: 'PayPal Abilitato',
      vrPaymentEnabled: 'VR Abilitato',
      rekaEnabled: 'Reka Abilitato',
      twintEnabled: 'Twint Abilitato',
      walleeEnabled: 'Wallee Abilitato',
      tacEnabled: 'Tac Abilitato',
      comoLoyaltyEnabled: 'Como Fedeltà Abilitato',
      tipRefundEnabled: 'Rimborso Mancia Abilitato',
      alipayEnabled: 'Alipay Abilitato',
      wcEnabled: 'WeChat Pay Abilitato',
      bcEnabled: 'Boncard Abilitato',
      lchEnabled: 'Luncheck Abilitato',
      cwlEnabled: 'Worldline Abilitato',
      ccvEnabled: 'CCV Abilitato',
      zeroPaymentEnabled: 'Pagamento Zero Abilitato',
      woltPaymentEnabled: 'Pagamento Wolt Abilitato',
      uberEatsPaymentEnabled: 'Pagamento Uber-Eats Abilitato',
      jetPaymentEnabled: 'Pagamento JET Abilitato',
      deliverooPaymentEnabled: 'Pagamento Deliveroo Abilitato',
      kostCardPaymentEnabled: 'Pagamento Carta KOST Abilitato',
      ctCreditCardPaymentEnabled: 'Carta di Credito Computop Abilitata',
      bankTransferPaymentEnabled: 'Bonifico Bancario Abilitato',
      dataTransEnabled: 'Datatrans Abilitato',
      piggyGiftCardEnabled: 'Piggy GiftCard Abilitata',
      piggyPrepaidBalanceEnabled: 'Piggy Prepaid Balance Abilitata',
      sapCCOEnabled: 'SAP CCO Abilitato',
      worldlineEnabled: 'Worldline Abilitato',
      wlApplePayEnabled: 'Worldline Apple Pay Abilitato',
      wlApplePayMobileEnabled: 'Worldline Apple Pay Mobile Abilitato',
      wlGooglePayEnabled: 'Worldline Google Pay Abilitato',
      wlGooglePayMobileEnabled: 'Worldline Google Pay Mobile Abilitato',
      wlCardEnabled: 'Worldline Carta Abilitata',
      wlCardMobileEnabled: 'Worldline Carta Mobile Abilitata',
      pfEnabled: 'PostFinance E-Finance Abilitato',
      pfcEnabled: 'PostFinance Card Abilitata',
      ppV2Enabled: 'PayPal V2 Abilitato',
      ppFullIntegrationEnabled: 'Integrazione Completa PayPal Abilitata',
      ccEnabled: 'Carta di Credito Abilitata',
      posEnabled: 'POS Abilitato',
      cashEnabled: 'Contanti Abilitati',
      neptingEnabled: 'Nepting Abilitato',
      eServiceEnabled: 'eService Abilitato',
      vippsEnabled: 'Vipps Abilitato',
      swishEnabled: 'Swish Abilitato',
      mobilePayEnabled: 'MobilePay Abilitato',
      dankortEnabled: 'Dankort Abilitato',
      maxxvendEnabled: 'MAXXvend Abilitato',
      amexEnabled: 'Amex Abilitato',
      secretKey: 'Chiave Segreta',
      merchantName: 'Nome Commerciante',
      creditorId: 'ID Creditore',
      merchantId: 'ID Commerciante',
      merchantIdPP: 'ID Commerciante',
      userId: 'ID Utente',
      spaceId: 'ID Spazio',
      userKey: 'Chiave Utente',
      reka: 'Reka',
      twint: 'Twint',
      boncard: 'Boncard',
      luncheck: 'Luncheck',
      postfinance: 'Postfinance',
      postfinanceCard: 'Postfinance Card',
      wechat: 'Wechat',
      alipay: 'Alipay',
      worldline: 'Worldline',
      ppEmail: 'E-Mail Account',
      ppEmailConfirmed: 'Email PayPal Confermata',
      ppEmailNotConfirmed: 'Email PayPal non Confermata',
      ppPaymentsReceivable: 'Pagamenti PayPal sono ricevibili',
      ppPaymentsNotReceivable: 'Pagamenti PayPal non sono ricevibili',
      vrAccessToken: 'Token Accesso VR-Payment',
      articleSpanCount: 'Conteggio Span Articoli',
      categorySpanCount: 'Conteggio Span Categorie',
      fullWidthCategories: 'Categorie a Larghezza Intera',
      showInactiveArticles: 'Mostra Articoli Interattivi',
      askForTableNumber: 'Chiedi Numero Tavolo',
      foodAndBeveragesSeparated: 'Cibo e Bevande Separati',
      toolbarTitleHidden: 'Titolo Barra Strumenti Nascosto',
      displayCirclePickerDescription: 'Mostra Descrizione Selettore Cerchio',
      toolbarCategoryListVisible: 'Barra Strumenti Elenco Categorie Visibile',
      toolbarSidesVisible: 'Barra Strumenti Contorni Visibile',
      multiLanguage: 'Multilingua',
      printQr: 'Stampa QR',
      firstOrderOffset: 'Offset Ordine Più Antico',
      orderOffset: 'Offset Ordine Minimo',
      lastOrderOffset: 'Offset Ordine Più Recente',
      dailyUnsnoozeTime: 'Offset Articolo',
      offsetResetEnabled: 'Reimposta tempo di preparazione abilitato',
      offsetResetTime: 'Ora',
      pickupBoxKey: 'Chiave Pickup Box',
      pickupBoxDeviceId: 'ID Dispositivo Pickup Box',
      pickupBoxAppId: 'ID App Pickup Box',
      pickupBoxCredentials: 'Credenziali Pickup Box',
      id: 'Id',
      apiGateway: 'Api Gateway',
      apiKey: 'Chiave Api',
      apiSecret: 'Segreto Api',
      apiUrl: 'Url Api',
      establishmentId: 'ID Stabilimento',
      dataTransMerchantId: 'ID Commerciante DataTrans',
      dataTransMerchantPassword: 'Password Commerciante DataTrans',
      dataTransMerchantWebhookKey: 'Chiave Webhook Commerciante DataTrans',
      pspId: 'ID Psp',
      host: 'Host',
      sdCredentials: 'Credenziali Sd',
      orderOffsetHint:
        "Inserisci quanti minuti dopo l'apertura devono passare prima di accettare il primo ordine, 60 = 1 ora",
      lastOrderOffsetHint:
        'Inserisci quanti minuti prima della chiusura del negozio può essere ricevuto un ordine, 60 = 1 ora',
      preorderOffset: 'Offset Preordine Minimo',
      preorderOffsetHint:
        "Inserisci quanti minuti dopo l'apertura devono passare prima di accettare il primo ordine, 60 = 1 ora",
      firstPreorderOffset: 'Offset Preordine Più Antico',
      lastPreorderOffset: 'Offset Preordine Più Recente',
      lastPreorderOffsetHint:
        'Inserisci quanti minuti prima della chiusura del negozio può essere ricevuto un ordine, 60 = 1 ora',
      phoneHint: 'es. +4912345678901',
      autoDeclineTime: 'Tempo di annullamento',
      uploadedFile: 'File caricato',
      terms: 'Termini e Condizioni',
      imprint: 'Imprint',
      privacy: 'Privacy',
      accessibility: 'Dichiarazione di Accessibilità',
      other: 'Altro Documento',
      registerCourt: 'Registro Tribunale',
      registerNumber: 'Numero Registro',
      chiefExecutives: 'Amministratori Delegati',
      sepaMandateRef: 'Riferimento Mandato SEPA',
      sepaMandateRegistrationLink: 'Link Registrazione Mandato SEPA',
      sepaMandateRegistrationError: 'Errore Registrazione Mandato SEPA',
      piggyLoyaltyEnabled: 'Piggy Fedeltà Abilitato',
      webAppSlug: 'Slug App Web',
      takeAway: 'Take Away',
      delivery: 'Consegna',
      foodspot: 'Foodspot',
      terminalUsername: 'Nome Utente Terminale',
      terminalPassword: 'Password Terminale',
      mobileUsername: 'Nome Utente Mobile',
      mobilePassword: 'Password Mobile',
      deliveryProviders: {
        orderLord: 'OrderLord',
        rushHour: 'Rush Hour',
        woltDrive: 'Wolt Drive',
        ultraDispo: 'Ultra Dispo',
        orderLordEnabled: 'Abilitato',
        orderLordActive: "OrderLord Disponibile (impostato dall'amministratore)",
        orderLordToken: 'Token API OrderLord',
        orderLordPassword: 'Password API OrderLord',
        rushhourIntegration: 'Integrazione Rush Hour Abilitata',
        rushhourToken: 'Token Rush Hour',
        woltdriveToken: 'Token Wolt Drive',
        woltdriveMerchantId: 'ID Wolt Drive',
        smoothrDispatchEnabled: 'Smoothr Dispatch Abilitato',
        customerId: 'ID Cliente',
        clientId: 'ID Client',
        clientSecret: 'Segreto Client',
        batchSize: 'Dimensione Batch',
        enabled: 'Abilitato',
        merchantUsername: 'Nome Utente Commerciante',
        merchantPassword: 'Password Commerciante',
        deliverableOrderTypes: 'Tipi di Ordine Consegnabili',
        pinVerificationEnabled: 'Verifica PIN Abilitata',
        pinVerificationMinimumAmount: 'Importo Totale Minimo Ordine Verifica PIN',
        dishbee: 'Dishbee',
        kurierzentrale: 'Kurierzentrale',
        botToken: 'Bot-Token',
        channelId: 'ID Canale',
        username: 'Nome Utente',
        password: 'Password',
        partnerId: 'ID Partner',
        averageDeliveryTime: 'Tempo di Consegna Medio',
      },
      externalOrderProviders: {
        useExternalProviders: 'Usa fornitori di ordini esterni',
        generalSettings: 'Impostazioni Generali',
        skipExternalOrderValidation: 'Accetta ordine con articoli inattivi',
        skipExternalOrderValidationNotice:
          "Se abilitato, accetta ordini dai fornitori di ordini, anche se l'ordine contiene articoli che sono DISATTIVATI in smoothr.",
        sendOrdersWithInactiveArticlesToPos: "Invia l'ordine con articolo inattivo al POS",
        orderDirectEnabled: 'OrderDirect Abilitato',
        orderDirectImprint: 'Imprint OrderDirect',
        woltEnabled: 'Wolt Abilitato',
        autoSyncTimesEnabled: 'Sincronizza orari automaticamente',
        enableAutoOrderReady: 'Imposta ordini automaticamente come pronti',
        connectWolt: 'Entra su Wolt',
        connectUberEats: 'Entra su Uber Eats',
        syncAllFoodcards: 'Sincronizza tutte le Foodcard',
        uberEatsEnabled: 'Uber Eats Abilitato',
        jetEnabled: 'JET Abilitato',
        deliverooEnabled: 'Deliveroo Abilitato',
        storeId: 'ID Negozio',
        siteId: 'ID Sito',
        brandId: 'ID Marca',
        coverPhotoUrl: 'Immagine Menu',
        menuDescription: 'Descrizione Menu',
        apiVersion: 'Versione API',
        venue: 'ID Punto Vendita',
        username: 'Nome Utente',
        password: 'Password',
        orderApiKey: 'Chiave Ordine Api',
        apiKey: 'Chiave Api',
        syncFoodcard: 'Sincronizza foodcard',
        syncStatus: 'Stato Sincronizzazione Punto Vendita',
        syncOpeningHours: 'Sincronizza Orari di apertura',
        foodcardSyncStarted: 'La sincronizzazione del menu è stata aggiunta alla coda e verrà avviata a breve.',
        online: 'Il punto vendita è stato attivato. Gli ordini sono ora possibili',
        offline: 'Il punto vendita è stato disattivato. Gli ordini non sono possibili.',
        openingHoursSynched: 'Gli orari di apertura sono stati sincronizzati.',
        preparationTime: 'Tempo di preparazione medio',
        deliveryTime: 'Tempo di consegna medio',
        autoAccept: 'Accetta automaticamente ordini',
        autoAcceptByPos: 'Accetta automaticamente (POS)',
        ocuFlowEnabled: 'Flusso OCU',
        articleAvailabilitySyncEnabled: 'Sincronizza Disponibilità Articoli',
        clientId: 'ID Client',
        clientSecret: 'Segreto Client',
        checkoutIntegrationDelayingEnabled: 'Ritarda integrazione checkout (POS)',
        autoSyncEnabled: 'Sincronizza foodcard automaticamente',
        enforceDeliveryMenuHours: 'Applica orari menu consegna',
        providerTabletEnabled: 'Tablet Fornitore Abilitato',
        ignorePosStatusEvents: 'Ignora Eventi Stato POS',
        dispatchMode: 'Modalità di consegna',
        articleDependencyMode: 'Modalità dipendenza articolo',
        providerVenueModes: {
          provider_delivery: 'Consegna da fornitore',
          own_delivery: 'Consegna dal ristorante',
        },
        articleDependencyModes: {
          ignore_article: 'Ignora articolo principale',
          ignore_dependency_only: 'Aggiungi articolo, ma ignora dipendenze',
        },
        refreshAlert: 'Aggiorna la pagina per vedere le modifiche',
        shouldReplaceDeposit: 'Sostituisci articolo cauzione',
        visible: 'Visibile',
        defaultPreparationTime: 'Tempo di Preparazione Predefinito',
        defaultPreparationTimeHint:
          'Se il reset automatico è abilitato, il tempo di preparazione verrà automaticamente impostato su questo valore dopo un certo periodo di tempo.',
      },
      invoiceReceiver: {
        email:
          "Indirizzo email alternativo del destinatario della fattura (altrimenti verrà utilizzata l'email di contatto)",
      },
      deliveryFeesAfterCreation:
        'Le tariffe di consegna possono essere specificate nelle impostazioni del punto vendita dopo la creazione.',
      sanifairEnabled: 'Integrazione Sanifair',
      sanifairBingoEnabled: 'Sanifair Bingo Attivo',
      sanifairLocationId: 'ID Posizione Sanifair',
      sanifairDeviceId: 'ID Dispositivo Sanifair',
      addExternalDelivery: 'Aggiungi servizio di consegna esterno',
      deleteExternalDelivery: 'Elimina',
      customerSupportMail: {
        email: 'E-Mail',
      },
      sandboxUrl: 'URL Sandbox',
      clientId: 'ClientId',
      clientSecret: 'Client Secret',
      username: 'Nome Utente',
      password: 'Password',
      recordType: 'Tipo Record',
      channelPc: 'Canale Pc',
      enabled: 'Abilitato',
      ccvApikey: 'ccvApikey',
      comoApiKey: 'comoApiKey',
      installationId: 'ID Installazione',
      locationId: 'ID Posizione',
      authenticationToken: 'Token Autenticazione',
      defaultTemplate: 'Modello Predefinito',
      disabledFields: 'Campi Disabilitati',
      disabledFieldsList: {
        allergens: 'Allergeni',
        template: 'Modello',
        pictograms: 'Pittogrammi',
        description_translations: 'Traduzioni Descrizione',
        disclamer_translations: 'Traduzioni Disclaimer',
      },
      syncMenu: 'Sincronizza Menu',
      activateForm: 'Attiva il Modulo',
      boardingPassVerificationEnabled: 'Valida Boarding-Pass',
      paxControlScanningPositionId: 'ID Posizione Scansione Pax Control',
      costCenter: 'Centro di costo',
      ecrNumber: 'Numero ECR',
      account: 'Conto',
      offsetAccount: 'Conto di contropartita',
      actions: {
        addPaymentMapping: 'Aggiungi Mappatura Metodo Pagamento',
        removePaymentMapping: 'Rimuovi Mappatura Metodo Pagamento',
        addOrderTypeMapping: 'Aggiungi Mappatura Tipo Ordine',
        removeOrderTypeMapping: 'Rimuovi Mappatura Tipo Ordine',
      },
      paymentMethodMappings: 'Mappature Metodi Pagamento',
      orderTypeMappings: 'Mappature Tipi Ordine',
      checkoutIntegrationProps: {
        serviceUrl: 'Url Servizio',
        orgname: 'Nome Org',
        orgShortName: 'Nome Breve Org',
        locRef: 'Rif Loc',
        rvcRef: 'Rif Rvc',
        username: 'Nome Utente',
        password: 'Password',
        clientId: 'ID Client',
        authUrl: 'Url Auth',
        defaultEmployee: 'Dipendente Predefinito',
        defaultOrderType: 'Tipo Ordine Predefinito',
        orderTypeInside: 'Tipo Ordine Interno',
        orderTypeTakeAway: 'Tipo Ordine Take Away',
        orderTypeDelivery: 'Tipo Ordine Consegna',
        orderTypeFoodspot: 'Tipo Ordine Foodspot',
        serviceChargeTip: 'Mancia Servizio',
        serviceChargeDeliveryFee: 'Tariffa Consegna Servizio',
        orderTypeInsideTerminal: 'Tipo Ordine Interno Terminale',
        orderTypeTakeAwayTerminal: 'Tipo Ordine Take Away Terminale',
        firetimeOffset: 'Offset Firetime',
        averageDeliveryTime: 'Tempo di Consegna Medio',
        useExternalId: 'Usa ID Esterno',
        autoSyncEnabled: 'Abilita Autosincronizzazione Visibilità',
        priceAutoSyncEnabled: 'Abilita Autosincronizzazione Prezzi',
        useSanifairAsTender: 'Usa Sanifair Come Tender',
        useTableAsEmployee: 'Usa Tavolo Come Dipendente',
        useCodeAsOrderCode: 'Usa Codice Come Codice Ordine',
        useSecondaryCodeAsOrdercode: 'Usa Codice Secondario Come Codice Ordine',
        retryOnApiCrash: 'Riprova In Caso Di Crash Api',
        skipRetryOnPosError: 'Salta Riprova In Caso Di Errori POS',
        useZeroCode: 'Usa Codice Zero',
        orderChannelRef: 'Rif Canale Ordine',
        orderChannelRefMapping: 'Mappatura Rif Canale Ordine',
        addOrderChannelRefMapping: 'Aggiungi Mappatura Rif Canale Ordine',
        firetimeEnabled: 'Firetime Abilitato',
        sendOrderNotes: 'Invia Note Ordine',
        hideTableName: 'Nascondi Nome Tavolo',
        healthcheckEnabled: 'Health Check Abilitato',
        multiConventional: 'Multi Convenzionale',
        cancelTenderType: 'Tipo Annullamento Ordine',
        cashPaymentCancelTimeout: 'Timeout Annullamento Pagamento Contanti',
        useCancelTenderType: 'Usa Tipo Annullamento Ordine',
        excludedTenders: 'Tender Esclusi (da Multi-Convenzionale)',
        multiConventionalRevenueCenters: 'Centri Ricavi Multi Convenzionali',
        multiConventionalOrderProfiles: 'Profili Ordine Multi Convenzionali',
        sentBoardingPassEnabled: 'Invio boarding pass abilitato',
        sentRbiLoyaltyEnabled: 'Invio RBI Fedeltà Abilitato',
        recalculatePayment: 'Ricalcola Pagamento',
        replaceCashOrdersByVirtualOrders: 'Sostituisci Ordini Contanti con Ordini Virtuali',
        deepHierarchyOnMultiConventionalOrders: 'Gerarchia Profonda su Ordini Multiconvenzionali',
        priceSequence: 'Sequenza Prezzo',
        orderProfile: 'Profilo Ordine',
        taxRate: 'Aliquota IVA',
        sku: 'SKU',
        value: 'Valore',
        prices: 'Prezzi',
        zeroPaymentMapping: 'Mappatura Metodo Pagamento (Pagamento Zero)',
        postfinanceMapping: 'Mappatura Metodo Pagamento (Postfinance)',
        preparationTime: 'Tempo di Preparazione Medio',
        deliveryTime: 'Tempo di Consegna Medio',
        piggyPrepaidBalance: 'Piggy Prepaid Balance',
        piggyGiftCard: 'Piggy GiftCards',
        allowManualBooking: 'Consenti prenotazione manuale',
        useTerminalName: 'Usa campo nome terminale invece di "TERMINAL"',
        sendTableNumberAsOrderNote: 'Invia numero tavolo come nota ordine',
        financialApiEnabled: 'Ricevute attivate',
        discountArticles: 'Articoli Sconto',
        depositArticles: 'Articoli cauzione',
        deposit: 'Cauzione',
        discountAsArticlesEnabled: 'Invia Sconto come Articolo',
        revenueCenter: 'Centro Ricavi',
        terminalRevenueCenters: 'Centri Ricavi Terminale',
        preOrderRevenueCenters: 'Centri Ricavi Preordine',
        externalOrderProviderRevenueCenters: 'Centri Ricavi Fornitori Ordini Esterni',
        addTerminalRevenueCenter: 'Aggiungi Centro Ricavi Terminale',
        addPreOrderRevenueCenter: 'Aggiungi Centro Ricavi Preordine',
        addExternalOrderProviderRevenueCenter: 'Aggiungi Centro Ricavi Fornitore Ordini Esterno',
        externalOrderProviderType: 'Tipo Fornitore Ordini Esterno',
        cncEnabled: 'CNC Abilitato',
        webhookEnabled: 'Webhook Simphony Abilitati',
        cncAuthUrl: 'URL Autenticazione CNC',
        cncUsername: 'Nome Utente CNC',
        cncPassword: 'Password CNC',
        cncClientId: 'ID Client CNC',
        cncApiUrl: 'URL API CNC',
        cncHierUnit: 'ID Unità Hier CNC',
        useNotesAsOrderCodeEnabled: 'Invia note ordine come codice ordine',
        default: 'Predefinito',
        paymentMethod: 'Metodo Pagamento',
        revelType: 'Tipo Revel',
        ncrType: 'Tipo NCR',
        useSimphonyPrice: 'Usa Prezzo Simphony',
        disabledFields: 'Campi Payload Disattivati',
        stockMode: 'Modalità Magazzino',
        nepOrganization: 'Organizzazione Nep',
        nepEnterpriseUnit: 'Unità Enterprise Nep',
        secretKey: 'Chiave Segreta',
        sharedKey: 'Chiave Condivisa',
        integrationKey: 'Chiave Integrazione',
        license: 'Licenza',
        tipPaymentMethod: 'Metodo Pagamento Mancia',
        arcavisId: 'Arcavis ID',
      },
      addTip: 'Aggiungi Mancia',
      removeTip: 'Rimuovi Mancia',
      addDefaultTip: 'Aggiungi Mancia Predefinita',
      tipEnabled: 'Mancia Abilitata',
      orderType: 'Tipo Ordine',
      subOrderTypes: 'Sotto Tipi Ordine',
      subOrderType: 'Sotto Tipo Ordine',
      defaultTips: 'Mance Predefinite',
      defaultTipValue: 'Valore Mancia Predefinito',
      defaultTipType: 'Tipo Mancia Predefinito',
      defaultTip: 'Mancia Predefinita',
      panicReason: 'Motivo Panico',
      accountName: 'Nome Account',
      tipTypes: {
        absolute: 'Valore fisso',
        relative: 'Percentuale',
        any: 'Qualsiasi valore',
      },
      salesforcePromotionsEnabled: 'Promozioni Salesforce Abilitate',
      voucherify: {
        enabled: 'Abilitato',
        appId: 'ID App',
        appKey: 'Chiave App',
        loyaltyCampaign: 'Campagna Fedeltà',
      },
      grubtech: {
        enabled: 'Abilitato',
        storeId: 'ID Negozio',
        apiKey: 'Chiave API',
        partnerId: 'ID Partner',
        integrationName: 'Nome integrazione',
      },
      finances: {
        customerNumber: 'Numero Cliente',
        licences: 'Licenze',
        sot: 'Numero di SOT',
        sco: 'Numero di SCO',
        operator: 'Numero di Licenze Operatore',
        pickup: 'Numero di Licenze PickUp',
        driveIn: 'Numero di Licenze DriveIn',
        menuboard: 'Numero di Licenze Menuboard',
        custom: 'Licenze Aggiuntive',
        hardware: 'Hardware/Dispositivi',
        addHardware: 'Aggiungi Hardware/Dispositivo',
        removeHardware: 'Rimuovi Hardware/Dispositivo',
        count: 'Conteggio',
        rentStartedAt: 'Noleggio iniziato il',
        rentEndedAt: 'Noleggio terminato il',
      },
    },
    legal: {
      useTemplate: 'Usa Modello',
      termsHtml: '',
      imprintHtml: '',
      privacyHtml: '',
      accessibilityHtml: '',
      otherHtml: '',
    },
    infoOpeningHours: {
      openingHours: `- Puoi aggiungere orari di apertura per singoli giorni facendo clic su un giorno e scegliendo un intervallo di tempo. Per salvare gli orari di apertura, fai clic sull'icona dell'orologio.<br />
      - Selezionando più giorni alla volta, puoi aggiungere gli stessi orari di apertura per quei giorni. Per salvare gli orari di apertura, fai clic sull'icona dell'orologio.<br />
      - Puoi anche aggiungere più orari di apertura per un giorno ripetendo i passaggi per impostare i singoli orari di apertura.`,
      specialOpeningHours: `- Se desideri che il tuo ristorante abbia orari di apertura speciali in un giorno specifico (es. festività), puoi aggiungerli qui. Basta scegliere una data e aggiungere gli orari speciali.<br />
      - Se desideri chiudere il tuo ristorante in una data specifica, puoi scegliere il giorno e selezionare la casella di controllo Ristorante chiuso. Il ristorante rimarrà chiuso per l'intera giornata.<br />
      - Altrimenti, se devi chiudere il tuo ristorante per un periodo di tempo specifico in una data speciale, puoi scegliere la data e un intervallo di tempo, quindi selezionare la casella di controllo Ristorante chiuso. Il ristorante sarà chiuso per questo specifico intervallo di tempo.<br />
      - Assicurati di aver prima aggiunto gli orari di apertura. Altrimenti, i tuoi orari di apertura speciali non verranno salvati.`,
    },
    infoDeliveryHours: {
      deliveryHours: `- Puoi aggiungere orari di consegna per singoli giorni facendo clic su un giorno e scegliendo un intervallo di tempo. Per salvare gli orari di consegna, fai clic sull'icona dell'orologio.<br />
      - Selezionando più giorni alla volta, puoi aggiungere gli stessi orari di consegna per quei giorni. Per salvare gli orari di consegna, fai clic sull'icona dell'orologio.<br />
      - Puoi anche aggiungere più orari di consegna per un giorno ripetendo i passaggi per impostare i singoli orari di consegna.`,
      specialDeliveryHours: `- Se desideri che il tuo ristorante abbia orari di consegna speciali in un giorno specifico (es. festività), puoi aggiungerli qui. Basta scegliere una data e aggiungere gli orari speciali.<br />
      - Se desideri chiudere il tuo ristorante per le consegne in una data specifica, puoi scegliere il giorno e selezionare la casella di controllo Ristorante chiuso. Il ristorante sarà chiuso per le consegne per l'intera giornata.<br />
      - Altrimenti, se devi chiudere il tuo ristorante per le consegne per un periodo di tempo specifico in una data speciale, puoi scegliere la data e un intervallo di tempo, quindi selezionare la casella di controllo Ristorante chiuso. Il ristorante sarà chiuso per le consegne per questo specifico intervallo di tempo.<br />
      - Assicurati di aver prima aggiunto gli orari di consegna. Altrimenti, i tuoi orari di consegna speciali non verranno salvati.`,
    },
  },
  analytic: {
    from: 'Da',
    to: 'A',
  },
  stats: {
    index: 'Gestisci Statistiche',
    indexAnalytics: 'Gestisci Analytics',
    totalNumberOfOrders: 'Numero di Ordini',
    avgOrdersPerDay: 'Ø Numero di Ordini/Giorno',
    avgAmount: 'Ø Valore ordine',
    totalAmount: 'Somma Totale',
    totalSoldArticles: 'Articoli Venduti',
    highestDaysSale: 'Ricavo Giornaliero Più Alto',
    totalPreCheckouts: 'Precheckout Confermati',
    paymentMethod: 'Metodo di Pagamento',
    avgOrderDuration: 'Ø Tempo ordine',
    totalTimeouts: 'Numero di timeout',
    monthSales: 'Vendite mensili',
    selectVenue: 'Seleziona prima il punto vendita',
    customerGroup: 'Gruppo Clienti',
    ui: {
      country: 'Paese',
      search: 'Cerca',
      bestSold: 'Più venduti',
      worstSold: 'Meno venduti',
      ordersView: 'Visualizzazione ordini',
      articleView: 'Visualizzazione articoli',
      quantity: 'Quantità',
      orders: 'Ordini',
      price: 'Prezzo',
      refresh: 'Aggiorna',
      debug: 'TEST',
      prod: 'PRODUZIONE',
      customerGroup: 'GruppoClienti',
      flavor: 'Seleziona Gusto(i)',
      status: 'Seleziona Stato(i)',
      checkoutIntegrationStatus: 'Seleziona Stato(i) POS',
      paymentMethod: 'Seleziona Metodo(i) di Pagamento',
      smoothrOnly: 'Solo Smoothr',
      table: 'Seleziona Tipo(i)',
      type: 'Seleziona Tavolo(i)',
      platforms: 'Seleziona Piattaforma(e)',
      label: 'Seleziona Etichetta',
      externalOrderProvider: 'Seleziona Fornitore',
      searchId: 'Cerca ID',
      searchCode: 'Cerca Codice',
      number: 'Numero',
      copyOrderId: 'Copia ID ordine',
      orderId: 'ID Ordine',
      note: 'Nota',
      today: 'Oggi',
      yesterday: 'Ieri',
      monthly: 'Mensile',
      daily: 'Giornaliero',
      showReceipts: 'Mostra Ricevute',
      showLogs: 'Mostra Log',
      logs: 'Log',
      more: 'altro',
      deliveryFee: 'Tariffa Consegna',
    },
    table: {
      order: 'Ordine',
      paymentMethod: 'Metodo di Pagamento',
      date: 'Data',
      orderDate: 'Data Ordine',
      orderTime: 'Ora Ordine',
      customer: 'Cliente',
      time: 'Ora',
      qty: 'Quantità',
      venue: 'Punto Vendita',
      itemName: 'Articoli',
      allCat: 'Tutte le Categorie',
      cat: 'Categorie',
      type: 'Tipo Ordine',
      subType: 'Sottotipo Ordine',
      status: 'Stato',
      table: 'Tavolo',
      price: 'Prezzo/Articolo',
      total: 'Totale',
      name: 'Nome',
      note: 'Nota',
      secondaryCode: 'Codice Secondario',
      dndCompanyCode: 'Codice Azienda',
      retry: 'Riprova',
      createdAt: 'Creato',
      level: 'Livello',
      source: 'Sorgente',
      logs: 'Log',
      provider: 'Fornitore',
      loyaltyArticles: 'Articoli Fedeltà',
      orderedArticles: 'Articoli Ordinati',
      clientMeta: 'Meta Client',
      platform: 'Piattaforma',
      device: 'Dispositivo',
      browser: 'Browser',
      appVersion: 'Versione App',
      osVersion: 'Versione OS',
      externalOrderId: 'ID Ordine Esterno',
      room: 'Stanza',
      pickupStation: 'Stazione di Ritiro',
      checkoutIntegrationStatus: 'Stato POS',
      promoCode: 'Codice Promo',
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
    },
  },
  sales: {
    index: 'Vendite Prodotto',
    ui: {
      category: 'Seleziona Categoria(e)',
      item: 'Seleziona Articolo(i)',
      label: 'Seleziona Etichetta Punto Vendita',
      dateType: 'Tipo Data',
      createdAt: 'Data Ordine',
      orderAt: 'Data Ritiro/Consegna',
    },
    table: {
      name: 'Nome',
      sales: 'Vendite',
      total: 'Totale',
      cat: 'Categoria',
    },
  },
  salesOverview: {
    index: 'Panoramica Vendite',
    filter: {
      customerGroup: 'Gruppo clienti',
      flavor: 'Gusto',
    },
    table: {
      venue: 'Punto Vendita',
      webApp: 'App Web',
      terminal: 'Terminale',
      terminalTakeaway: 'Takeaway Terminale',
      terminalInside: 'Interno Terminale',
      wolt: 'Wolt',
      uberEats: 'Uber Eats',
      jet: 'Jet',
      pickup: 'Ritiro',
      delivery: 'Consegna',
      total: 'Totale',
      orders: 'Ordini',
      amount: 'Importo',
      totalOrders: 'Ordini Totali',
      totalAmount: 'Importo Totale',
      inside: 'Webshop Interno',
      foodspot: 'Foodspot',
      orderAtTable: 'Ordina al Tavolo',
    },
  },
  billing: {
    index: 'Fatturazione',
    billing: 'Esporta Fatturazione',
    orderCsv: "Esporta Ordini (L'esportazione verrà inviata all'email con cui hai effettuato l'accesso.)",
    foodspotExport: "Esporta Foodspot (L'esportazione verrà inviata all'email con cui hai effettuato l'accesso.)",
    paymentMethodCsv:
      "Esporta Ordini per Metodo di Pagamento (L'esportazione verrà inviata all'email con cui hai effettuato l'accesso.)",
    salesCsv: "Esporta Vendite (L'esportazione verrà inviata all'email con cui hai effettuato l'accesso.)",
    salesGroup: "Esporta gruppo vendite (L'esportazione verrà inviata all'email con cui hai effettuato l'accesso.)",
    summary: 'Esporta Riepilogo Fatturazione',
    plainSummary: 'Esporta Riepilogo Fatturazione Semplice',
    datev: 'Esporta Datev',
    articlesOverview: 'Tipo ordine',
    wallet: 'Esporta Portafoglio',
    form: {
      venue: 'Punto Vendita',
      company: 'Azienda',
      label: 'Etichetta punto vendita',
      flavor: 'Gusto',
      customerGroup: 'Gruppo Clienti',
      withoutTags: 'Non filtrare etichette "vuote"',
      showExpanded: 'Mostra dati espansi',
      subscribedToMailing: 'Iscritto alla newsletter',
      filterEmptyByMail: 'Filtra vuoti per email',
      typeExportFile: 'Tipo di file esportato',
      requiredField: 'Scegli uno dei campi',
    },
  },
  userExport: {
    index: 'Esportazione utenti',
    userExport: 'Esporta utente',
    userCsv: 'Esporta utenti',
    userWithNewsletterCsv: 'Esporta utenti con newsletter',
    form: {},
  },
  activityLogExport: {
    index: 'Esportazione Log Attività',
    activityLogCsv: 'Esporta log',
    form: {
      type: 'Tipo',
      venue: 'Punto Vendita',
      typeExportFile: 'Tipo di file esportato',
    },
  },
  sepa: {
    index: 'SEPA',
    title: 'Impostazioni SEPA',
    mandate: 'Mandato',
    sepaMandate: 'Mandato SEPA',
    venues: 'Punti Vendita',
    createSepa: 'Crea nuovo Mandato SEPA',
    debit: 'Addebito SEPA',
    payLast: 'Paga fatture degli ultimi 30 giorni',
    notification: {
      cancelError: "Errore durante l'annullamento del Mandato SEPA",
      cancelWarning:
        'Sei sicuro di voler annullare questo Mandato SEPA? Verrà rimosso e non potrà più essere utilizzato per i pagamenti.',
      createError: 'Impossibile creare un nuovo link di registrazione mandato SEPA',
      createWarning:
        'Sei sicuro di voler creare un nuovo link di registrazione Mandato SEPA? I Mandati SEPA esistenti per i punti vendita selezionati verranno rimossi e non potranno più essere utilizzati per i pagamenti.',
      payWarning:
        'Esiste un Mandato SEPA per questo punto vendita. Vuoi creare un nuovo pagamento SEPA per questa transazione?',
      payLastTransactionsWarning:
        'Sei sicuro di voler autorizzare i pagamenti per tutte le fatture degli ultimi 30 giorni per questi punti vendita? Successivamente i singoli pagamenti possono essere annullati entro 2 giorni. In questo caso contatta immediatamente il supporto.',
      payLastTransactionsSuccess:
        "Fatture degli ultimi 30 giorni pagate. Riceverai un'email per ogni pagamento autorizzato. Contatta il supporto entro 2 giorni se desideri annullare uno dei pagamenti.",
    },
    form: {
      merchantId: 'ID Commerciante',
      venues: 'Punti Vendita',
      merchantName: 'Nome Commerciante',
      payLastTransactionsAfterCreate: 'Paga fatture aperte degli ultimi 30 giorni *',
      payLastTransactionsAfterCreateHint:
        "Tutti gli importi delle fatture aperte degli ultimi 30 giorni verranno addebitati dal nostro sistema dopo la creazione del mandato SEPA. Riceverai un'email per ogni pagamento autorizzato nelle prossime ore. Contatta il supporto entro 2 giorni se desideri annullare uno di questi pagamenti.",
      sepaMandateRef: 'Riferimento Mandato SEPA',
      sepaMandateRegistrationLink: 'Link Registrazione Mandato SEPA',
      sepaMandateRegistrationError: 'Errore Registrazione Mandato SEPA',
    },
  },
  productCombos: {
    index: 'Combinazioni prodotto',
    overview: 'Panoramica',
  },
  tips: {
    terminal: 'Terminale',
    webApp: 'App Web',
    inside: 'Interno',
  },
  promo: {
    index: 'Gestisci Codici Promo',
    create: 'Crea un nuovo Codice Promo',
    edit: 'Modifica Codice Promo',
    exportCsv: 'Esporta',
    exportSummary: 'Esporta Riepilogo',
    exportCount: 'Esporta Riepilogo Attivazione',
    overviewCsv: 'Esporta Codici Promo',
    exportTeedeliZip: 'Esporta Codici Promo Teedeli (*.zip)',
    exportGeneralOverview: 'Esporta Panoramica Generale',
    overview: 'Panoramica',
    add: 'Aggiungi Codice Promo',
    addTeedeli: 'Aggiungi Codice Promo Teedeli',
    addMultiple: 'Aggiungi Più Codici Promo',
    disableCodes: 'Disabilita Codici',
    syncPiggyVouchers: 'Sincronizza Voucher Piggy',
    syncPiggyVouchersSuccess: 'I voucher Piggy sono stati sincronizzati con successo.',
    syncPiggyVouchersError:
      'Si è verificato un errore durante la sincronizzazione dei voucher Piggy. Riprova più tardi.',
    disableHint: 'Seleziona prima un punto vendita',
    notification: {
      disableSuccess: 'Codici Promo disabilitati con successo.',
    },
    types: {
      absolute: 'Valore Assoluto',
      relative: 'Valore Relativo',
      bogo: 'BOGO',
      deliveryFee: 'Nessuna Consegna Gratuita',
      reward: 'Ricompensa',
      giftCard: 'Carta Regalo',
      freeArticle: 'Articolo Gratuito',
      void: 'Void',
      absoluteArticle: 'Sconto Articolo (assoluto) - DEPRECATO',
      relativeArticle: 'Sconto Articolo (relativo) - DEPRECATO',
      singleAbsoluteArticle: 'Sconto Articolo (assoluto)',
      singleRelativeArticle: 'Sconto Articolo (relativo)',
      multipleAbsoluteArticle: 'Sconto Articoli Multipli (assoluto)',
      multipleRelativeArticle: 'Sconto Articoli Multipli (relativo)',
      dependencyFreeArticle: 'Articolo Gratuito con Dipendenza',
      cheapestFreeArticle: 'Articolo Più Economico Gratuito',
      cheapestHalfArticleDiscountRelative: 'Sconto sulla metà degli articoli',
      mostExpensiveArticleDiscountRelative: 'Sconto Articolo Più Costoso (relativo)',
      teedeliPremium: 'Sconto Articolo (premium)',
      unlockArticles: 'Sblocca Articoli',
      coupon: 'Coupon',
      multipleFreeArticles: 'Articoli Gratuiti Multipli',
    },
    table: {
      name: 'Nome',
      code: 'Codice',
      customerGroup: 'Gruppo Clienti',
      mov: 'Valore Minimo Ordine',
      from: 'Valido da',
      to: 'Valido a',
      disabled: 'Disabilitato (Solo Punto Vendita)',
      venues: 'Punti Vendita',
      type: 'Tipo',
      value: 'Valore',
      active: 'Attivo (Globale)',
      disabledBy: 'Disabilitato da',
      countries: 'Paesi',
      states: 'Stati',
      amount: 'Utilizzo Massimo',
      unlimited: 'Illimitato',
    },
    form: {
      offerPeriod: 'Periodo Offerta',
      unlimitedTime: 'Tempo Illimitato',
      unlimitedAmount: 'Utilizzo Illimitato',
      lightspeedCode: 'Codice Lightspeed',
      simphonyCode: 'Codice Simphony',
      useCustomerRedemptionCodes: 'PromoCodes come codici monouso',
      name: 'Nome',
      code: 'Codice',
      description: 'Descrizione',
      venue: 'Punto Vendita',
      valid: 'Valido',
      article: 'Articolo',
      generateAmount: 'Quantità da generare',
      label: 'Etichetta Punto Vendita',
      isMultipleApplicable: 'Il cliente può usarlo più di una volta',
      applyOnAnyQuantity: 'Applica su Qualsiasi Quantità',
      customerGroup: 'Gruppo Clienti',
      countries: 'Paesi',
      states: 'Stati/Regioni',
      codes: 'Codici Promo',
      uploadGiftCards: 'File CSV con Carte Regalo',
      venues: 'Punti Vendita',
      type: 'Tipo',
      freeArticle: 'Articolo Gratuito',
      bogoArticles: 'Articoli Possibili (il prodotto più economico dal carrello verrà utilizzato per bogo)',
      mov: 'Valore Minimo Ordine',
      amount: 'Utilizzo massimo',
      amountTeedeli: 'Numero di codici promo',
      amountUsesTeedeli: 'Utilizzo Max',
      active: 'Attivo',
      value: 'Valore',
      discount: 'Sconto',
      percent: 'Valore (es. 20% inserire 0.2)',
      standardAvailability: 'Disponibile',
      insideAvailability: 'Disponibile interno',
      takeAwayAvailability: 'Disponibile per take away',
      deliveryAvailability: 'Disponibile per consegna',
      preorderParkCollect: 'Disponibile per park & collect',
      preorderFoodspot: 'Disponibile per foodspot',
      webAvailability: 'Disponibile',
      isMaster: 'È Master',
      generalPromoCode: 'Codice Promo Generale',
      registrationRequired: 'Registrazione Richiesta',
      boundToUser: "Legato all'Utente",
      usageFrequency: 'Frequenza di utilizzo',
      minQuantity: 'Quantità Minima',
      maxQuantity: 'Numero massimo di articoli scontabili',
      isAutomatic: 'Attiva automaticamente',
      isPiggyVoucher: 'Voucher Piggy',
      banner: 'Banner',
      discountableMainCategories: 'Categorie Principali Scontabili',
    },
    usageFrequency: {
      any: 'Qualsiasi',
      daily: 'Giornaliero',
      weekly: 'Settimanale',
      monthly: 'Mensile',
    },
    tabs: {
      general: 'Generale',
      availability: 'Disponibilità',
      images: 'Immagini',
      availableHours: 'Orari disponibili',
      banner: 'Banner',
    },
    standardAvailability: 'Disponibilità Standard',
    terminalAvailability: 'Disponibilità Terminale',
    preorderAvailability: 'Disponibilità Preordine',
    webAvailability: 'Disponibilità Web',
    weekdaysAvailability: 'Disponibilità Giorni Feriali',
    cateringAvailability: 'Disponibilità Catering',
  },
  cupCode: {
    index: 'Gestisci Codice Bicchiere',
    create: 'Crea un nuovo Codice Bicchiere',
    edit: 'Modifica Codice Bicchiere',
    overview: 'Panoramica',
    add: 'Aggiungi Codice Bicchiere',
    downloadCodes: 'Esporta Codici',
    downloadQRCode: 'Scarica codici QR',
    action: 'Azioni su un intervallo di codici',
    form: {
      number: 'Numero',
      venue: 'Punto Vendita',
      active: 'Attivo',
      quantity: 'Numero di codici da generare',
      startingFrom: 'Numero iniziale dei codici',
      customerGroup: 'Seleziona gruppi clienti',
      format: 'Seleziona formato file',
    },
    table: {
      number: 'Numero',
      venue: 'Punto Vendita',
      customerGroup: 'Gruppi Clienti',
      quantity: 'Quantità',
      startingFrom: 'A Partire Da',
      active: 'Attivo',
      qrCode: 'Codice QR',
      createdAt: 'Creato',
    },
    filter: {
      customerGroup: 'Gruppi Clienti',
      active: 'Attivo',
      numFrom: 'Numero Da',
      numTo: 'Numero A',
    },
  },
  coupon: {
    index: 'Gestisci Coupon (deprecato)',
    create: 'Crea un nuovo Coupon',
    edit: 'Modifica Coupon',
    exportCsv: 'Esporta',
    exportSummary: 'Esporta Riepilogo',
    exportCount: 'Esporta Riepilogo Attivazione',
    overviewCsv: 'Esporta Coupon',
    overview: 'Panoramica',
    add: 'Aggiungi Coupon',
    addMultiple: 'Aggiungi Coupon Multipli',
    disableCodes: 'Disabilita Coupon',
    disableHint: 'Seleziona prima un punto vendita',
    notification: {
      disableSuccess: 'Coupon disabilitati con successo.',
    },
    form: {
      offerPeriod: 'Periodo Offerta',
      lightspeedCode: 'Codice Lightspeed',
      name: 'Nome',
      code: 'Codice',
      venue: 'Punto Vendita',
      valid: 'Valido',
      article: 'Articolo',
      generateAmount: 'Quantità da generare',
      label: 'Etichetta Punto Vendita',
      isMultipleApplicable: 'Il cliente può usarlo più di una volta',
      applyOnAnyQuantity: 'Applica su Qualsiasi Quantità',
      customerGroup: 'Gruppo Clienti',
      countries: 'Paesi',
      states: 'Stati/Regioni',
      codes: 'Coupon',
      uploadGiftCards: 'File CSV con Carte Regalo',
      venues: 'Punti Vendita',
      type: 'Tipo',
      freeArticle: 'Articolo Gratuito',
      bogoArticles: 'Articoli Possibili (il prodotto più economico dal carrello verrà utilizzato per bogo)',
      mov: 'Valore Minimo Ordine',
      amount: 'Utilizzo massimo',
      active: 'Attivo',
      value: 'Valore',
      discount: 'Sconto',
      percent: 'Valore (es. 20% inserire 0.2)',
      standardAvailability: 'Disponibile',
      insideAvailability: 'Disponibile interno',
      takeAwayAvailability: 'Disponibile per take away',
      deliveryAvailability: 'Disponibile per consegna',
      preorderParkCollect: 'Disponibile per park & collect',
      preorderFoodspot: 'Disponibile per foodspot',
      webAvailability: 'Disponibile',
      image: 'Immagine',
      banner: 'Banner',
      usageFrequency: 'Frequenza di utilizzo',
      redeemableAtCheckoutOnly: 'Riscattabile',
    },
    types: {
      absolute: 'Valore Assoluto',
      relative: 'Valore Relativo',
      bogo: 'BOGO',
      deliveryFee: 'Nessuna Consegna Gratuita',
      reward: 'Ricompensa',
      giftCard: 'Carta Regalo',
      freeArticle: 'Articolo Gratuito',
      void: 'Void',
      absoluteArticle: 'Sconto Articolo (assoluto)',
      relativeArticle: 'Sconto Articolo (relativo)',
      plusOneFree: '1 + 1 Gratuito',
    },
    usageFrequency: {
      any: 'Qualsiasi',
      daily: 'Giornaliero',
      weekly: 'Settimanale',
      monthly: 'Mensile',
    },
    table: {
      name: 'Nome',
      code: 'Codice',
      customerGroup: 'Gruppo Clienti',
      mov: 'Valore Minimo Ordine',
      from: 'Valido da',
      to: 'Valido a',
      disabled: 'Disabilitato (Solo Punto Vendita)',
      venues: 'Punti Vendita',
      type: 'Tipo',
      value: 'Valore',
      active: 'Attivo (Globale)',
      disabledBy: 'Disabilitato da',
      countries: 'Paesi',
      states: 'Stati',
      amount: 'Utilizzo Massimo',
    },
    tabs: {
      general: 'Generale',
      availability: 'Disponibilità',
      images: 'Immagini',
    },
    standardAvailability: 'Disponibilità Standard',
    terminalAvailability: 'Disponibilità Terminale',
    preorderAvailability: 'Disponibilità Preordine',
    webAvailability: 'Disponibilità Web',
    weekdaysAvailability: 'Disponibilità Giorni Feriali',
    cateringAvailability: 'Disponibilità Catering',
  },
  receipt: {
    index: 'Ricevute',
    overview: 'Panoramica',
    receipts: 'Ricevute',
    endOfDayReceipts: 'Ricevute Fine Giornata',
    form: {
      flavor: 'Gusto Ordine',
      venue: 'Punto Vendita',
    },
    table: {
      code: 'Codice Ordine',
      at: 'Alle',
      sum: 'Somma',
      endOfDay: 'Fine giornata',
      merchantReceipt: 'Ricevuta Commerciante',
      customerReceipt: 'Ricevuta Cliente',
      posCheckoutReceipt: 'Ricevuta Checkout',
      exportCustomer: 'Esporta ricevuta cliente',
      exportMerchant: 'Esporta ricevuta commerciante',
      exportCombined: 'Esporta ricevuta commerciante e cliente',
      exportFull: 'Esporta ricevute',
      tableNumber: 'Numero Tavolo',
    },
  },
  eposJobs: {
    index: 'Lavori',
    overview: 'Panoramica',
    form: {
      venue: 'Punto Vendita',
      status: 'Stato',
      requestId: 'ID Richiesta',
      success: 'Riuscito',
      failed: 'Fallito',
      partiallyFailed: 'Parzialmente Fallito',
      pending: 'In attesa',
      started: 'Avviato',
      sortByCreatedAt: 'Data ultima creazione',
      oldestToNewest: 'Dal più vecchio al più nuovo',
      newestToOldest: 'Dal più nuovo al più vecchio',
    },
    table: {
      sapNumber: 'Numero Sap',
      status: 'Stato',
      statusMessage: 'Messaggio Stato',
      createdAt: 'Creato il',
      finalizedAt: 'Finalizzato il',
      exportFull: 'Esporta ricevute',
      requestId: 'ID Richiesta',
      ID: 'ID Modifiche',
      articleType: 'Tipo Articolo',
      itemId: 'ID Articolo',
      price: 'Prezzo',
      taxInside: 'IVA Interno',
      taxTakeaway: 'IVA Takeaway',
      visibility: 'Visibilità',
      oldValue: 'Vecchio Valore',
      newValue: 'Nuovo Valore',
      priceRuleId: 'ID Regola Prezzo',
      effectiveDateTimestamp: 'Timestamp Data Effettiva',
      expirationDateTimestamp: 'Timestamp Data Scadenza',
      priceRuleSet: 'Set Regole Prezzo',
      statusCode: 'Codice Stato',
      taxIdInside: 'ID IVA Interno',
      taxIdTakeaway: 'ID IVA Takeaway',
      errorList: 'Elenco errori',
      errorId: 'ID Errore',
      articleName: 'Nome Articolo',
      negativeFlag: 'Flag Negativo',
      exportRawRequest: 'Esporta Richiesta Grezza',
      exportChanges: 'Esporta Modifiche',
    },
  },
  sanifairLogs: {
    index: 'Sanifair',
    overview: 'Panoramica',
    form: {
      venue: 'Punto Vendita',
      status: 'Stato',
      search: 'Cerca',
      actionTypes: 'Tipi Azione',
    },
    table: {
      sanifairActionType: 'Tipi Azione',
      order: 'Ordine',
      responseTimeSanifair: 'Tempo Risposta Sanifair',
      responseTimeSmoothr: 'Tempo Risposta Smoothr',
      responseTimeTotal: 'Tempo Risposta Totale',
      createdAt: 'Creato il',
      sanifairRequestReceivedAt: 'Richiesta Sanifair Ricevuta il',
      sanifairResponseReceivedAt: 'Risposta Sanifair Ricevuta il',
      smoothrRequestReceivedAt: 'Richiesta Smoothr Ricevuta il',
      smoothrResponseReceivedAt: 'Risposta Smoothr Ricevuta il',
    },
  },
  automatedReports: {
    index: 'Report Automatici',
    overview: 'Panoramica',
    add: 'Aggiungi Report Automatico',
    form: {
      type: 'Tipo',
      venue: 'Punto Vendita',
      customerGroup: 'Gruppo Clienti',
      flavor: 'Gusto',
      lang: 'Lingua',
      frequency: 'Frequenza',
      venueLabels: 'Etichette Punto Vendita',
      lastExecuted: 'Ultima Esecuzione',
      receiver: 'Destinatario',
      cc: 'CC',
      active: 'Attivo',
    },
    tabs: {
      general: 'Generale',
    },
    table: {
      type: 'Tipo',
      customerGroup: 'Gruppo Clienti',
      flavor: 'Gusto',
      frequency: 'Frequenza',
      venueLabels: 'Etichette Punto Vendita',
      lastExecuted: 'Ultima Esecuzione',
      receiver: 'Destinatario',
      selectVenue: 'Seleziona punto vendita',
      selectGroup: 'Seleziona gruppo clienti',
    },
    types: {
      orders: 'Ordini',
      orderByPaymentMethod: 'Ordine per Metodo di Pagamento',
      sales: 'Vendite',
      pdfBillingShort: 'PDF Fatturazione Breve',
      pdfBillingLong: 'PDF Fatturazione Lunga',
    },
    frequency: {
      daily: 'Giornaliero',
      weekly: 'Settimanale',
      monthly: 'Mensile',
      yearly: 'Annuale',
    },
  },
  paypal: {
    index: 'PayPal',
    success: 'Autorizzazione PayPal riuscita',
    description:
      'Autorizzazione PayPal riuscita. Dopo che i nostri dipendenti hanno verificato lo stato del tuo account, i pagamenti PayPal verranno attivati.',
  },
  validations: {
    eod_email_enable: "L'elenco deve contenere email valide prima di abilitarlo",
    list_of_emails: 'La tua email dovrebbe essere separata da una virgola.',
    list_of_integer: 'I tender esclusi devono essere separati da una virgola.',
    numbers_with_comma_or_dot: 'Il campo {field} deve essere un numero.',
    quantity_number: 'Il numero non può essere maggiore.',
    quantity_number_less_100k: 'La differenza non può essere superiore a 100.000 e inferiore a 0',
    quantity_number_less_10k: 'La differenza non può essere superiore a 10.000 e inferiore a 0',
    unique_email: "L'email è già in uso",
    admin_smoothr_email: 'Gli utenti amministratori devono usare un indirizzo email @smoothr.de.',
    readable_id: "L'ID breve è già stato preso.",
    venue_label: "L'etichetta del punto vendita esiste già.",
    password:
      'La password deve contenere una lettera maiuscola, un numero o un carattere speciale ed essere lunga almeno 8 caratteri.',
    identifier: "L'identificatore deve contenere solo lettere minuscole separate da un singolo trattino basso",
    date_before: 'Il campo {field} deve essere prima di {target}',
    time_before: 'Il campo {field} deve essere prima di {target}',
    unique_dependency: '{field} è un duplicato',
    smaller_eq_than: '{field} deve essere al massimo {target}.',
    smaller_than: '{field} deve essere minore di {target}.',
    greater_than: '{field} deve essere maggiore di {target}.',
    greater_eq_than: '{field} deve essere almeno {target}.',
    uppercase: 'Solo lettere maiuscole consentite',
    price: '{field} deve essere un prezzo valido (es. 1.99)',
    nutritional_value: '{field} deve essere un valore nutrizionale valido (es. 1.99)',
    uniqueFile: 'Il supporto caricato non può essere modificato. Si prega di creare un nuovo passaggio.',
    time: "Il formato dell'ora è HH:mm.",
    url: 'Inserisci un dominio valido senza http/https, solo il dominio e il TLD.',
    url_simple: 'Inserisci un URL completo valido con http/https',
    url_ios_android: '{field} deve essere un URL valido per lo store {storeType}',
    loyalty_campaign: '{field} deve essere una campagna valida che inizia con "camp_"',
    phone: 'Inserisci un numero di telefono valido (es. +4912345678901)',
    uniq_company_code: 'Questo codice azienda è già stato preso. Scegli un codice diverso.',
    iban: 'Formato IBAN non valido. Inserisci un IBAN corretto.',
    vatNumber: {
      info: 'È richiesta una Partita IVA valida con una lunghezza minima di 5',
      error:
        "La Partita IVA non è valida o è già stata utilizzata da un altro utente. Inserisci un'altra Partita IVA o contatta un amministratore per risolvere il problema.",
    },
    vatNumberGermany: {
      info: 'È richiesto un Numero Fiscale Tedesco valido con una lunghezza minima di 5',
      error:
        'Il Numero Fiscale Tedesco non è valido o è già stato utilizzato da un altro utente. Inserisci un altro Numero Fiscale o contatta un amministratore per risolvere il problema.',
    },
  },
  footer: {
    imprint: 'Imprint',
    terms: 'Politiche sui Dati',
  },
  reporting: {
    index: 'Reportistica',
    form: {
      type: 'Tipo',
      periodType: 'Periodo',
      label: 'Etichetta Punto Vendita',
      country: 'Paese',
      venue: 'Punto Vendita',
      flavor: 'Gusto',
      customerGroup: 'Gruppo Clienti',
    },
    periods: {
      daily: 'Giorno',
      weekly: 'Settimana',
      monthly: 'Mese',
      total: 'Totale',
    },
    types: {
      stores: 'Punto Vendita',
      products: 'Articolo',
      customers: 'Cliente',
    },
  },
  screensaver: {
    index: 'Salvaschermo',
    add: 'Crea Salvaschermo',
    mediaType: 'Tipo di supporto',
    duration: 'Durata',
    level: 'Livello',
    preview: 'anteprima',
    title: 'Passaggio Salvaschermo',
    hours: 'Ore',
    overview: 'Panoramica',
    stepSavingInfo: 'I supporti verranno caricati a breve, attendere.',
    category: 'Categoria',
    form: {
      name: 'Nome',
      customerGroup: 'Gruppo Clienti',
      linkedCustomerGroup: 'Gruppo Clienti Collegato',
      venues: 'Punti Vendita',
      openingHours: 'Orari di Apertura',
      file: 'Risorsa',
      duration: 'Durata in secondi',
      level: 'Livello',
      saveOrder: 'Salva nuovo ordine',
      changeOrder: 'Modifica ordine',
      slug: 'Slug',
      visible: 'Visibile',
      category: 'Categoria',
      articles: 'Articoli',
    },
    tabs: {
      screensaver: 'Salvaschermo',
      upsellArticles: 'Articoli Upsell',
      steps: 'Passaggi',
      info: 'Puoi aggiungere passaggi solo dopo aver creato il salvaschermo',
    },
    table: {
      steps: 'Conteggio Passaggi',
    },
  },
  employeeNotification: {
    index: 'Notifica Dipendente',
    add: 'Crea Notifica Dipendente',
    form: {
      title: 'Titolo',
      message: 'Messaggio',
    },
  },
  loyaltyPrograms: {
    index: 'Programmi Fedeltà',
    add: 'Crea Programma Fedeltà',
    create: 'Crea Programma Fedeltà',
    edit: 'Modifica Programmi Fedeltà',
    overview: 'Panoramica',
    general: 'Generale',
    clientCredentials: 'Credenziali Client',
    rbiCredentials: 'Credenziali RBI',
    form: {
      type: 'Tipo',
      customerGroup: 'Gruppo Clienti',
      apikey: 'Chiave API',
      oauthId: 'ID Oauth',
      oauthSecret: 'Segreto Oauth',
      operator: 'Operatore',
      posType: 'Tipo POS',
      storeId: 'ID Negozio',
      supportingPos: 'POS di Supporto',
      piggy: 'Piggy',
      como: 'Como',
      internal: 'Interno',
      rbi: 'RBI',
      shopUuid: 'UUID Negozio',
    },
    table: {
      type: 'Tipo',
      customerGroup: 'Gruppo Clienti',
      apikey: 'Chiave API',
      oauthId: 'ID Oauth',
      oauthSecret: 'Segreto Oauth',
      shopUuid: 'UUID Negozio',
      venue: 'Punto Vendita',
      operator: 'Operatore',
      posType: 'Tipo POS',
      storeId: 'ID Negozio',
      supportingPos: 'POS di Supporto',
    },
  },
  banner: {
    index: 'Gestisci Banner',
    add: 'Crea banner',
    table: {
      name: 'Nome',
      type: 'Tipo',
      linkedCategory: 'Categoria Collegata',
      linkedArticle: 'Articolo Collegato',
    },
    form: {
      name: 'Nome',
      type: 'Tipo',
      linkedCategory: 'Categoria Collegata',
      linkedArticle: 'Articolo Collegato',
      imageDe: 'Immagine (de)',
      imageEn: 'Immagine (en)',
      imageFr: 'Immagine (fr)',
    },
  },
  lightspeed: {
    syncFoodcard: 'Sincronizza',
    success: 'Lightspeed è stato autorizzato con successo',
    successDescription:
      "Congratulazioni! Lightspeed è stato autorizzato con successo. Contatta il tuo key account manager per completare l'integrazione. Puoi chiudere questa pagina ora.",
    error: 'Impossibile autorizzare Lightspeed',
    errorDescription:
      "Sfortunatamente, si è verificato un errore sconosciuto durante l'autorizzazione di Lightspeed. Contatta il supporto o il tuo key account manager. Puoi chiudere questa pagina ora.",
    notification: {
      foodcardSyncSuccess: 'Il menu è in fase di sincronizzazione. Ci vorranno circa 15 minuti.',
      foodcardSyncError: 'Impossibile sincronizzare il menu. Informare un amministratore.',
      tablesSyncSuccess: 'I tavoli sono in fase di sincronizzazione. Ci vorranno circa 5 minuti.',
      tablesSyncError: 'Impossibile sincronizzare i tavoli. Informare un amministratore.',
    },
    modes: {
      create_and_update: 'Sincronizza tutto',
      create_only: 'Sincronizza nuovi elementi',
      update_only: 'Sincronizza modifiche',
      price_and_active: 'Sincronizza prezzi/visibilità',
      price_only: 'Sincronizza solo prezzi',
      images_only: 'Sincronizza solo immagini',
      tables: 'Sincronizza tavoli',
    },
  },
  copy_venue: {
    not_selected_to: 'Devi selezionare una destinazione per copiare',
    success: 'Punto vendita copiato con successo',
    error: 'Qualcosa è andato storto',
    btn_title: 'Copia Impostazioni',
    from: 'Da',
    to: 'A',
  },
  sync: {
    index: 'Sincronizzazione',
    sync: 'Sincronizza',
    syncUpsells: 'Sincronizza Upsell',
    config: 'Configurazione',
    created: 'Creato',
    updated: 'Aggiornato',
    deleted: 'Eliminato',
    collapseAll: 'Comprimi Tutto',
    expandAll: 'Espandi Tutto',
    directions: {
      d2d: 'Dev-a-Dev',
      d2p: 'Dev-a-Prod',
      p2d: 'Prod-a-Dev',
      p2p: 'Prod-a-Prod',
    },
    notification: {
      running: 'La sincronizzazione è stata avviata',
      error: 'Si è verificato un errore. Controlla i log.',
    },
    modes: {
      'master-to-slaves': 'Master -> Slave',
      'slave-to-slaves': 'Slave -> Slave',
    },
    deleteModes: {
      ignore: 'Nessuna modifica/Nessuna eliminazione',
      soft: 'Soft-Delete',
      hard: 'Hard-Delete',
    },
    table: {
      id: 'Id',
      name: 'Nome',
      user: 'Utente',
      status: 'Stato',
      createdAt: 'Creato',
      today: 'Oggi',
      finishedAt: 'Completato',
      config: 'Configurazione',
      changes: 'Modifiche',
      stopSync: 'Interrompi Sincronizzazione',
      refresh: 'Aggiorna',
    },
    form: {
      main: 'Punto Vendita Principale (Slave/Master)',
      slaves: 'Punti Vendita Slave',
      direction: 'Da/A',
      mode: 'Modalità',
      deleteMode: 'Modalità eliminazione',
      articleCategoryProps: 'Proprietà Categoria',
      categories: 'Categorie',
      articleProps: 'Proprietà Articolo',
      venueProps: 'Proprietà Punto Vendita',
      optionGroupProps: 'Proprietà Gruppo Opzioni',
      optionArticleProps: 'Proprietà Articolo Opzione',
      selectAll: 'Seleziona Tutto',
      upsells: 'Upsell',
      useSyncTags: 'Sincronizza in base ai tag di sincronizzazione',
    },
    props: {
      articleCategory: {
        sortOrder: 'Ordinamento',
        visible: 'Visibilità',
        displayMode: 'Modalità Visualizzazione',
        displayIdentifiers: 'Identificatori Visivi',
        mainCategory: 'Categoria principale',
        availableHours: 'Orari disponibili',
        name: 'Nome',
        description: 'Descrizione',
        assets: 'Immagine principale',
        icon: 'Icona',
        tags: 'Etichette',
        constrains: 'Vincoli',
        features: 'Caratteristiche',
        mainRecommendations: 'Raccomandazioni principali',
        printerSortOrder: 'Ordine Stampante',
      },
      article: {
        price: 'Prezzo',
        basePrice: 'Prezzo base',
        taxTakeaway: 'IVA (Takeaway)',
        taxInside: 'IVA (Interno)',
        sortOrder: 'Ordinamento',
        visible: 'Visibilità',
        isActive: 'Stato attivo',
        deposit: 'Cauzione',
        isControlArticle: 'Flag articolo di controllo',
        internalNote: 'Nota interna',
        internalName: 'Nome Interno',
        externalId: 'ID Esterno',
        number: 'Numero',
        priceIsLocked: 'Blocco Prezzo',
        isNoticeable: 'Notevole',
        description: 'Descrizione',
        name: 'Nome',
        info: 'Info',
        shortDescription: 'Breve descrizione',
        assets: 'Immagine principale',
        icon: 'Icona',
        banner: 'Banner',
        measurement: 'Misurazione',
        groupDependencies: 'Dipendenze Gruppo',
        groups: 'Gruppi opzioni',
        defaults: 'Predefiniti',
        recommendations: 'Raccomandazioni',
        priceByType: 'Prezzo per tipo ordine',
        displayPriceByType: 'Prezzo Visibile per tipo ordine',
        availability: 'Disponibilità',
        tags: 'Etichette',
        constrains: 'Vincoli',
        counterArticle: 'Contatore articolo',
        mainRecommendations: 'Raccomandazioni principali',
        articleRelativeBrand: 'Marca',
        styles: 'Stili',
        additives: 'Additivi',
        allergens: 'Allergeni',
        features: 'Caratteristiche',
        traces: 'Tracce',
        externalOrderProviderSettings: 'Impostazioni Fornitore Ordini Esterno',
        loyaltyId: 'ID Fedeltà',
        requiredLoyaltyPoints: 'Punti Fedeltà Richiesti',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Valori nutrizionali',
        displayMode: 'Modalità Visualizzazione',
        displayModeSot: 'Modalità Visualizzazione (Sot)',
        displayModeMobile: 'Modalità Visualizzazione (Mobile)',
        manufacturer: 'Produttore',
        caffeineMg: 'Caffeina (mg)',
        alcoholPercentage: 'Percentuale Alcol',
        availableHours: 'Orari Disponibili',
        printerSortOrder: 'Ordine Stampante',
        dimension: 'Dimensioni',
        weight: 'Peso',
        foodInstructions: 'Istruzioni Alimentari',
        storageInstructions: 'Istruzioni Conservazione',
      },
      venue: {
        movDelivery: 'MOV',
        preorderTakeAway: 'Preordine (Takeaway)',
        preorderIn: 'Preordine (Interno)',
        deliveryEnabled: 'Preordine (Consegna)',
        sendProvisionReportPeriod: 'Report provvigione',
        isServiceActivated: 'Stato Servizio',
        offsets: 'Offset',
        invoiceReceiver: 'Destinatario fattura',
        slot: 'Slotting',
        legal: 'Legale',
        openingHours: 'Orari di apertura',
        deliveryHours: 'Orari di consegna',
        nutritionTable: 'Tabella nutrizionale',
        nutritionInfo: 'Info nutrizionali',
      },
      optionGroup: {
        hasMultiple: 'Selezione multipla',
        limit: 'Limite',
        sortOrder: 'Ordinamento',
        requiredAmount: 'Quantità richiesta',
        name: 'Nome',
        description: 'Descrizione',
        shortDescription: 'Breve descrizione',
        backgroundImage: 'Immagine di sfondo',
        tags: 'Etichette',
        displayMode: 'Modalità Visualizzazione',
        displayModeSot: 'Modalità Visualizzazione (Sot)',
        displayModeMobile: 'Modalità Visualizzazione (Mobile)',
        printerSortOrder: 'Ordine Stampante',
      },
      optionArticle: {
        price: 'Prezzo',
        basePrice: 'Prezzo base',
        taxTakeaway: 'IVA (Takeaway)',
        taxInside: 'IVA (Interno)',
        sortOrder: 'Ordinamento',
        visible: 'Visibilità',
        isActive: 'Stato attivo',
        deposit: 'Cauzione',
        isControlArticle: 'Flag articolo di controllo',
        internalNote: 'Nota interna',
        internalName: 'Nome Interno',
        foodInstructions: 'Istruzioni Alimentari',
        storageInstructions: 'Istruzioni Conservazione',
        externalId: 'ID Esterno',
        optionNumber: 'Numero',
        number: 'Numero',
        priceIsLocked: 'Blocco Prezzo',
        isNoticeable: 'Notevole',
        description: 'Descrizione',
        name: 'Nome',
        info: 'Info',
        shortDescription: 'Breve descrizione',
        assets: 'Immagine principale',
        icon: 'Icona',
        banner: 'Banner',
        measurement: 'Misurazione',
        groupDependencies: 'Dipendenze Gruppo',
        groups: 'Gruppi opzioni',
        defaults: 'Predefiniti',
        recommendations: 'Raccomandazioni',
        priceByType: 'Prezzo per tipo ordine',
        displayPriceByType: 'Prezzo Visibile per tipo ordine',
        availability: 'Disponibilità',
        tags: 'Etichette',
        constrains: 'Vincoli',
        counterArticle: 'Contatore articolo',
        mainRecommendations: 'Raccomandazioni principali',
        requirements: 'Requisiti articolo',
        articleRelativeBrand: 'Marca',
        styles: 'Stili',
        additives: 'Additivi',
        allergens: 'Allergeni',
        features: 'Caratteristiche',
        traces: 'Tracce',
        externalOrderProviderSettings: 'Impostazioni Fornitore Ordini Esterno',
        loyaltyId: 'ID Fedeltà',
        requiredLoyaltyPoints: 'Punti Fedeltà Richiesti',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Valori nutrizionali',
        manufacturer: 'Produttore',
        caffeineMg: 'Caffeina (mg)',
        alcoholPercentage: 'Percentuale Alcol',
        printerSortOrder: 'Ordine Stampante',
        dimensions: 'Dimensioni',
        weight: 'Peso',
      },
      upsell: {
        addon: 'Upsell Carrello',
        goal: 'Upsell Arrotondamento',
        upgrade: 'Upsell Articolo',
      },
    },
  },
  aggregatorSyncs: {
    index: 'Sincronizzazioni Aggregatore',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    deliveroo: 'Deliveroo',
    noWolt: 'Nessun dato Wolt disponibile.',
    noJet: 'Nessun dato Jet disponibile.',
    noUberEats: 'Nessun dato Uber-Eats disponibile.',
    noDeliveroo: 'Nessun dato Deliveroo disponibile.',
    table: {
      name: 'Nome',
      user: 'Utente',
      status: 'Stato',
      createdAt: 'Creato',
      finishedAt: 'Completato',
    },
    filter: {
      status: 'Seleziona Stato',
    },
    status: {
      created: 'Creato',
      in_progress: 'In Corso',
      done: 'Completato',
      failed: 'Fallito',
    },
  },
  posSync: {
    index: 'Sincronizzazione POS',
    table: {
      venue: 'Punto Vendita',
      status: 'Stato',
      user: 'Utente',
      syncMode: 'Modalità Sincronizzazione',
      errorMessage: 'Messaggio Errore',
      createdAt: 'Creato il',
      startedAt: 'Avviato il',
      finishedAt: 'Completato il',
      failedAt: 'Fallito il',
    },
  },
  orderProviders: {
    wolt: {
      success: {
        title: 'Punto vendita collegato con successo a Wolt',
        description:
          'Il tuo punto vendita è stato collegato con successo a Wolt. Ora puoi sincronizzare la tua foodcard e ricevere ordini.',
      },
      error: {
        title: 'Impossibile collegare il punto vendita a Wolt',
        description: 'Si è verificato un errore. Contatta il nostro supporto:',
      },
    },
    uberEats: {
      success: {
        title: 'Punto vendita collegato con successo a Uber Eats',
        description:
          'Il tuo punto vendita è stato collegato con successo a Uber Eats. Ora puoi sincronizzare la tua foodcard e ricevere ordini.',
      },
      error: {
        title: 'Impossibile collegare il punto vendita a Uber Eats',
        description: 'Si è verificato un errore. Contatta il nostro supporto:',
      },
    },
  },
  simphony: {
    syncFoodcard: 'Sincronizza prezzi/visibilità',
    syncPrices: 'Sincronizza solo prezzi',
    syncActive: 'Sincronizza solo visibilità',
    refreshCnc: 'Aggiorna CNC',
    fullSync: 'Sincronizzazione Completa',
    addOnly: 'Aggiungi solo',
    notification: {
      foodcardSyncSuccess: 'Prezzi/visibilità sincronizzati con successo.',
      foodcardSyncError: 'Impossibile sincronizzare prezzi/visibilità. Controlla i log.',
      pricesSyncSuccess: 'Prezzi sincronizzati con successo.',
      pricesSyncError: 'Impossibile sincronizzare i prezzi. Controlla i log.',
      activeSyncSuccess: 'Visibilità sincronizzate con successo.',
      activeSyncError: 'Impossibile sincronizzare le visibilità. Controlla i log.',
      refreshCncSuccess: 'CNC aggiornato con successo.',
      refreshCncError: 'Impossibile aggiornare CNC. Controlla i log.',
      addOnlySuccess: 'Nuovi elementi sincronizzati con successo.',
      addOnlyError: 'Impossibile sincronizzare nuovi elementi. Controlla i log.',
    },
  },
  kost: {
    syncFoodcard: 'Sincronizza foodcard',
    notification: {
      foodcardSyncSuccess: 'Foodcard sincronizzata con successo.',
      foodcardSyncError: 'Impossibile sincronizzare la foodcard. Controlla i log.',
    },
  },
  ncr: {
    syncFoodcard: 'Sincronizza foodcard',
    notification: {
      foodcardSyncSuccess: 'Foodcard sincronizzata con successo.',
      foodcardSyncError: 'Impossibile sincronizzare la foodcard. Controlla i log.',
    },
  },
  revel: {
    sync: 'Sincronizza',
    syncMenu: 'Sincronizza menu',
    notification: {
      menuSyncSuccess: 'Menu sincronizzato con successo.',
      menuSyncError: 'Impossibile sincronizzare il menu. Controlla i log.',
    },
    modes: {
      full: 'Sincronizzazione completa',
      add_only: 'Solo aggiunta',
      price_only: 'Solo prezzi',
      active_only: 'Solo visibilità',
    },
  },
  lina: {
    syncPrices: 'Sincronizza prezzi',
    notification: {
      pricesSyncSuccess: 'Prezzi sincronizzati con successo.',
      pricesSyncError: 'Impossibile sincronizzare i prezzi. Controlla i log.',
    },
  },
  ui: {
    banner: {
      index: 'Banner',
      overview: 'Panoramica',
      general: 'Dettagli',
      add: 'Crea Banner',
      create: 'Crea un nuovo Banner',
      edit: 'Modifica Banner',
      empty: 'Sembra che tu non abbia ancora aggiunto nessun banner. Crea ora il tuo primo banner!',
    },
    card: {
      index: 'Card',
      overview: 'Panoramica',
      general: 'Dettagli',
      add: 'Crea Card',
      create: 'Crea una nuova Card',
      edit: 'Modifica Card',
      empty: 'Sembra che tu non abbia ancora aggiunto nessuna card. Crea ora la tua prima card!',
    },
    slider: {
      index: 'Slider',
      overview: 'Panoramica',
      general: 'Dettagli',
      add: 'Crea Slider',
      create: 'Crea un nuovo Slider',
      edit: 'Modifica Slider',
      empty: 'Sembra che tu non abbia ancora aggiunto nessuno slider. Crea ora il tuo primo slider!',
    },
    form: {
      customerGroup: 'Gruppo Clienti',
      title: 'Titolo',
      identifier: 'Identificatore',
      textColor: 'Colore Testo',
      backgroundColor: 'Colore Sfondo',
      backgroundImage: 'Immagine di Sfondo',
      htmlContent: 'Contenuto HTML',
      primaryClickAction: 'Azione Click Primaria',
      type: 'Tipo',
      value: 'Valore',
      label: 'Etichetta',
      addAction: 'Aggiungi Azione',
      removeAction: 'Rimuovi Azione',
      slides: 'Diapositive',
      actionType: 'Tipo Azione',
      description: 'Descrizione',
      action: 'Azioni',
    },
  },
  releases: {
    index: 'Versioni',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea Versione',
    create: 'Crea una nuova Versione',
    edit: 'Modifica Versione',
    empty: 'Sembra che tu non abbia ancora aggiunto nessuna versione. Crea ora la tua prima versione!',
    form: {
      customerGroup: 'Gruppo Clienti',
      platform: 'Piattaforma',
      version: 'Versione',
      forceUpdate: 'Aggiornamento Forzato',
      description: 'Descrizione',
      link: 'Link',
      isLatest: 'Versione Corrente',
      isLatestHint: 'Se il campo è attivo, la versione corrente verrà sovrascritta.',
      platforms: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
    },
  },
  auditing: {
    index: 'Auditing',
    overview: 'Panoramica',
    table: {
      action: 'Azione',
      message: 'Oggetto',
      target: 'Risorsa',
      actor: 'Utente',
      changes: 'Modifiche',
      createdAt: 'Data',
      venue: 'Punto Vendita',
      customerGroup: 'Gruppo Clienti',
    },
  },
  enrollments: {
    index: 'Registrazioni',
    overview: 'Panoramica',
    accept: 'Accetta',
    reject: 'Rifiuta',
    comment: 'Commento',
    table: {
      deviceType: 'Tipo dispositivo',
      serialNumber: 'Numero seriale',
      venue: 'Punto Vendita',
      appInformation: 'App',
      role: 'Ruolo',
      enrollmentStatus: 'Stato',
      rolloutStatus: 'Stato Distribuzione',
      isActive: 'Attivo',
      venues: 'Punti Vendita',
      reviewerId: 'ID Revisore',
    },
  },
  campaign: {
    index: 'Campagna',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea Campagna',
    create: 'Crea una nuova Campagna',
    edit: 'Modifica Campagna',
    empty: 'Sembra che tu non abbia ancora aggiunto nessuna campagna. Crea ora la tua prima campagna!',
    form: {
      customerGroup: 'Gruppo Clienti',
      name: 'Nome',
      content: 'Contenuto',
      subject: 'Oggetto',
      clickAction: 'Azione Click',
      url: 'URL',
      venues: 'Punti Vendita',
      status: 'Stato',
      error: 'Errore',
      scheduledAt: 'Pianificato',
    },
    table: {
      customerGroup: 'Seleziona Gruppo Clienti',
    },
  },
  seasonPass: {
    index: 'Season Pass',
    warning: 'Un importazione riuscita sovrascrive tutte le voci esistenti.',
    upload: 'Carica CSV',
    csv: 'File CSV Season Pass',
    successfulUpload: 'Il tuo file CSV Season Pass è stato caricato con successo',
  },
  upsell: {
    index: 'Upsell',
    overview: 'Panoramica',
    types: {
      addon: 'Upsell Carrello',
      goal: 'Upsell Arrotondamento',
      upgrade: 'Upsell Articolo',
    },
    table: {
      position: 'Posizione',
      article: 'Articolo',
      upgradeFrom: 'PLU Piccolo',
      upgradeTo: 'PLU Grande',
      mov: 'Valore minimo ordine',
      roundTo: 'Arrotondato a',
      articles: 'PLU da aggiungere',
      plu: 'PLU',
    },
    form: {
      position: 'Posizione',
      article: 'Articolo',
      upgradeFrom: 'PLU Piccolo',
      upgradeTo: 'PLU Grande',
      mov: 'Valore minimo ordine',
      roundTo: 'Arrotondato a',
      articles: 'PLU da aggiungere',
      isMaster: 'È Master',
      isMasterNotice:
        'Non dimenticare di impostare il flag "È Master" (se necessario) prima di aggiungere il primo elemento. Altrimenti non potrai modificarlo in seguito',
    },
  },
  healthCheck: {
    index: 'Healthcheck',
    overview: 'Panoramica',
    general: 'Dettagli',
    add: 'Crea Healthcheck',
    create: 'Crea un nuovo Healthcheck',
    edit: 'Modifica Healthcheck',
    empty: 'Sembra che tu non abbia ancora aggiunto nessun Healthcheck. Crea ora il tuo primo healthcheck!',
    table: {
      venues: 'Punti Vendita',
      customerGroup: 'Gruppo Clienti',
      lastRunAt: 'Ultima Esecuzione il',
      status: 'Stato',
      errorList: 'Errori',
      article: 'Articolo',
      category: 'Categoria',
      type: 'Tipo',
    },
    form: {
      venues: 'Punti Vendita',
      customerGroup: 'Gruppo Clienti',
    },
  },
};
